<template>
  <div data-testid="ru-data-table">
    <!-- Interactive Data Table View - Shows for both Grouped and Ungrouped views -->
    <div v-if="toggletableview === 0" key="interactive-view">
      <div>
        <div class="table-responsive-wrapper">
          <v-simple-table dense class="main-table-style">
            <template v-slot:default>
              <thead v-if="!isRevenueBreakup" class="tableHeaderBg">
                <tr>
                  <th scope="navigation" rowspan="2" class="align-center" style="white-space: nowrap;" v-if="!isRevenueBreakup && !isGlNavigationEnabled">Navigation <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="forwardToggleExpandAll()" class="ml-2" data-testid="ru-data-table__expand-collapse-all-btn">
                          {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                        </v-icon>
                      </template>
                      <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
                    </v-tooltip>
                  </th>
                  <th class="" scope="multiselect" rowspan='2' style="white-space: nowrap;" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3"></th>
                  <th class="" scope="rucode" v-if="toggleview === 3" rowspan="2" style="white-space: nowrap;">{{$nova.labelsName('cycle_page','commentary_ru_code_label','RU Code')  }}</th>
                  <th class="" scope="runame" v-if="toggleview === 3" rowspan="2" style="white-space: nowrap;">{{ $nova.labelsName('cycle_page','ru_name','RU Name')  }}</th>
                  <th scope="type" class="gl-code-description-column" rowspan="2" style="width: 25%; min-width: 300px; white-space: nowrap;">
                    {{ isRevenueBreakup ? 'Client Code & Name' : $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') + ' & Description' }}
                    <template v-if="!isRevenueBreakup">
                      <v-btn class="shadow-off ml-2" name="filter-gl-code" icon @click.stop="$emit('open-custom-filters-dialog')" data-testid="ru-data-table__filter-btn">
                        <img src="../../../../public/img/icons/FilterIcon.svg" alt="Menu Filter Icon" class="filter-icon" />
                      </v-btn>
                    </template>
                  </th>
                  <th scope="status" class="text-left" rowspan="2" style="white-space: nowrap;">Status
                    <StatusFilterMenu
                      :selectedfilter="selectedfilter"
                      @update:selected-filter="$emit('update:selected-filter', $event)"
                    />
                  </th>
                  <th scope="amount1heading" rowspan="2" class="text-right" style="min-width: 140px; white-space: nowrap;">{{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}}</th>
                  <th v-if="showProformaColumns" scope="type" class="text-left" colspan="4" style="white-space: nowrap;">{{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}} Vs {{ proformaLabel }}</th>
                  <th v-if="showForecastColumns" scope="type" class="text-left" colspan="4" style="white-space: nowrap;"> {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}} Vs {{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel }} </th>
                </tr>
                <tr class="selected-header-row">
                  <th v-if="showProformaColumns" scope="amount2heading" class="text-right" style="min-width: 140px; white-space: nowrap;">
                    {{ proformaLabel }}
                  </th>
                  <th v-if="showProformaColumns" scope="flags" class="text-right" style="white-space: nowrap;">Flags</th>
                  <th v-if="showProformaColumns" scope="varianceamt" class="text-right" style="min-width: 140px; white-space: nowrap;">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt')  }} </th>
                  <th v-if="showProformaColumns" scope="variancepercent" class="text-right" style="min-width: 100px; white-space: nowrap;">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance')  }} % </th>
                  <th v-if="showForecastColumns" scope="amount2heading" class="text-right" style="min-width: 140px; white-space: nowrap;">
                    {{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel}}
                  </th>
                  <th v-if="showForecastColumns" scope="flags" class="text-right" style="white-space: nowrap;">Flags</th>
                  <th v-if="showForecastColumns" scope="varianceamt" class="text-right" style="min-width: 140px; white-space: nowrap;">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt')  }}</th>
                  <th v-if="showForecastColumns" scope="variancepercent" class="text-right" style="min-width: 100px; white-space: nowrap;">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance')  }} %</th>
                </tr>
              </thead>
              <thead v-else class="tableHeaderBg" data-testid="ru-data-table__revenue-header">
                <tr>
                  <th v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3" rowspan="2" scope="multiselect" class="text-center">
                    <v-checkbox
                      :input-value="isAllSelectableRowsChecked"
                      :indeterminate="isSelectAllIndeterminate"
                      @change="handleToggleSelectAll"
                      hide-details
                      dense
                      class="ma-0 pa-0"
                      color="primary"
                      :aria-label="$nova.labelsName('cycle_page', 'select_label', 'Select')"
                      data-testid="ru-data-table__select-all-toggle"
                    ></v-checkbox>
                  </th>
                  <th rowspan="2" style="min-width: 180px;">
                    <div class="d-flex align-center">
                      <span>{{ $nova.labelsName('cycle_page', 'client_code_label', 'Client Code') }}</span>
                      <ClientFilterMenu
                        filter-type="code"
                        :title="$nova.labelsName('cycle_page', 'filter_client_code_label', 'Filter by Client Code')"
                        :selected-values="selectedClientCodes"
                        :options="uniqueClientCodes"
                        @update:selected-values="$emit('update:selected-client-codes', $event)"
                      />
                    </div>
                  </th>
                  <th rowspan="2" style="min-width: 200px;">
                    <div class="d-flex align-center">
                      <span>{{ $nova.labelsName('cycle_page', 'client_name_label', 'Client Name') }}</span>
                      <ClientFilterMenu
                        filter-type="name"
                        :title="$nova.labelsName('cycle_page', 'filter_client_name_label', 'Filter by Client Name')"
                        :selected-values="selectedClientNames"
                        :options="uniqueClientNames"
                        @update:selected-values="$emit('update:selected-client-names', $event)"
                      />
                    </div>
                  </th>
                  <th rowspan="2" class="text-left">
                    <div class="d-flex align-center">
                      <span>{{ $nova.labelsName('cycle_page', 'status_label', 'Status') }}</span>
                      <StatusFilterMenu
                        :selectedfilter="selectedfilter"
                        @update:selected-filter="$emit('update:selected-filter', $event)"
                      />
                    </div>
                  </th>
                  <th rowspan="2" class="text-left">{{ actualAmountLabel }}</th>
                  <th v-if="showProformaColumns" colspan="5" class="text-left">{{ actualVsProformaHeading }}</th>
                  <th v-if="showForecastColumns" colspan="5" class="text-left">{{ actualVsForecastHeading }}</th>
                  <th rowspan="2" class="text-center action-header">{{ $nova.labelsName('cycle_page','commentary_action_label','Action') }}</th>
                </tr>
                <tr class="selected-header-row">
                  <template v-if="showProformaColumns">
                    <th class="text-left">{{ proformaShortLabel }}</th>
                    <th class="text-left">Flags</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt') }}</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance') }} %</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_comments_label','Comments') }}</th>
                  </template>
                  <template v-if="showForecastColumns">
                    <th class="text-left">{{ forecastComparisonBaseLabel }}</th>
                    <th class="text-left">Flags</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt') }}</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance') }} %</th>
                    <th class="text-left">{{ $nova.labelsName('cycle_page','commentary_comments_label','Comments') }}</th>
                  </template>
                </tr>
              </thead>
              <tbody v-if="!isRevenueBreakup">
                <!-- Empty state when no filtered results -->
                <tr v-if="displayItems.length === 0 && !(ungroupedGLItems && ungroupedGLItems.length > 0)" data-testid="ru-data-table__empty-row">
                  <td :colspan="getListViewColspan" class="text-center pa-6">
                    <NoDataState
                      class="py-6 text--secondary"
                      data-testid="ru-data-table__empty-state"
                      :title="varianceUiCopy.FILTER_NO_DATA_TITLE"
                      :description="varianceUiCopy.NO_FILTER_RESULTS_DESCRIPTION"
                      :icon="varianceUiCopy.NO_FILTER_RESULTS_ICON"
                      :icon-size="varianceUiCopy.NO_FILTER_RESULTS_ICON_SIZE"
                    >
                      <p
                        class="text-caption mt-1 mb-0"
                        data-testid="ru-data-table__empty-hint"
                      >
                        {{ varianceUiCopy.NO_FILTER_RESULTS_HINT }}
                      </p>
                    </NoDataState>
                  </td>
                </tr>
                <tr v-for="v in displayItems" 
                :key="v._id" 
                class="tree-table cursor-pointer" 
                :class="{ 'clickable-gl-row': v.__code !== 'NA', 'sl-enabled-row': cycletype === 'Actual' && v.glcode_detail && v.glcode_detail.sub_ledger_exists, 'gl-priority-row': v.glcode_detail && v.glcode_detail.priority === 1 }"
                v-intersect.quiet="getIntersectHandler(v)"
                data-testid="ru-data-table__row"
                @click="handleRowClick(v, $event)">
                  <template v-if="v.__code === 'NA'">
                    <td @click.stop="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                      <div class="tree-node-wrapper">
                        <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                          <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                            <div 
                              :key="'connector-' + idx"
                              class="tree-connector-segment"
                              :class="[
                                'tree-level-' + connector.level,
                                {
                                  'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                                  'is-current-level': connector.isCurrentLevel,
                                  'is-last-child': connector.isLastChild,
                                  'is-first-child': connector.isFirstChild,
                                  'is-inverted': connector.isInverted
                                }
                              ]"
                              :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                            >
                              <div 
                                class="vertical-line" 
                                v-if="connector.showVerticalLine || connector.isCurrentLevel"
                                :class="{ 
                                  'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                                  'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                                }"
                              ></div>
                              <div 
                                class="horizontal-branch" 
                                v-if="connector.isCurrentLevel"
                              ></div>
                            </div>
                          </template>
                        </div>
                        <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                          <span v-if="shouldShowExpandIcon" class="expand-icon">
                            <template v-if="hasChildren(v) && !isFilterSet">
                              <v-icon small data-testid="ru-data-table__expand-icon-na">
                                {{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}
                              </v-icon>
                              <div v-if="isExpanded(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]"></div>
                            </template>
                            <template v-else>
                              <v-icon small class="leaf-node-icon" color="primary" data-testid="ru-data-table__leaf-icon-na">mdi-checkbox-blank</v-icon>
                            </template>
                          </span>
                        </div>
                        <!-- Line extending from expanded parent to children - color based on child level -->
                        <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                      </div>
                    </td>
                    <td class="pl-2 pr-0" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3">
                    </td>
                    <td class="gl-code-description-cell" colspan="12">
                      <div class="d-flex align-center">
                        <span class="gl-code-description-text">
                          <span class="gl-code">NA</span>
                          <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                        </span>
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="!isRevenueBreakup && cycletype === 'Actual' && v.sl_enabled">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon class="ml-2" target="_blank" @click.stop="forwardSLData(v, 'netsales', true)" data-testid="ru-data-table__sl-drill-btn">
                              <!-- <v-icon>mdi-format-list-bulleted</v-icon> -->
                              <img src="../../../../public/img/icons/DrillDown.svg" alt="Drill Down Icon" />
                            </v-btn>
                          </template>
                          <span>Drill Down</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </template>
                  <template v-else>
                    <td @click.stop="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                      <div class="tree-node-wrapper">
                        <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                          <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                            <div 
                              :key="'connector-' + idx"
                              class="tree-connector-segment"
                              :class="[
                                'tree-level-' + connector.level,
                                {
                                  'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                                  'is-current-level': connector.isCurrentLevel,
                                  'is-last-child': connector.isLastChild,
                                  'is-first-child': connector.isFirstChild,
                                  'is-inverted': connector.isInverted
                                }
                              ]"
                              :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                            >
                              <div 
                                class="vertical-line" 
                                v-if="connector.showVerticalLine || connector.isCurrentLevel"
                                :class="{ 
                                  'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                                  'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                                }"
                              ></div>
                              <div 
                                class="horizontal-branch" 
                                v-if="connector.isCurrentLevel"
                              ></div>
                            </div>
                          </template>
                        </div>
                        <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                          <span v-if="shouldShowExpandIcon" class="expand-icon">
                            <template v-if="hasChildren(v) && !isFilterSet">
                              <v-icon small data-testid="ru-data-table__expand-icon">
                                {{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}
                              </v-icon>
                              <div v-if="isExpanded(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]"></div>
                            </template>
                            <template v-else>
                              <v-icon small class="leaf-node-icon" color="primary" data-testid="ru-data-table__leaf-icon">mdi-checkbox-blank</v-icon>
                            </template>
                          </span>
                        </div>
                        <!-- Line extending from expanded parent to children - color based on child level -->
                        <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                      </div>
                    </td>
                    <td class="pl-0 pr-0" @click.stop="hasChildren(v)" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3">
                      <v-checkbox multiple v-model="localMultiselectdata" :value="v._id" name="select-gl-code" hide-details dense class="pa-0 ma-0 navigation-checkbox-cycle" :data-test="v.__type === 'header' ? 'parent-checkbox' : 'child-checkbox'"></v-checkbox>
                    </td>
                    <td v-if="toggleview === 3">{{ getRuCode(v.cycle) }}</td>
                    <td v-if="toggleview === 3">{{ getRuName(v.cycle) }}</td>
                    <td class="gl-code-description-cell">
                      <div class="">
                        <template v-if="isRevenueBreakup">
                          <div :class="'padding-level-' + v.level" class="mr-2">
                            <span v-if="hasChildren(v) && shouldShowExpandIcon" class="expand-icon">
                              <v-icon data-testid="ru-data-table__revenue-expand-icon">{{ isExpanded(v) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                            </span>
                            <span v-else class="no-children-spacer" style=""></span>
                          </div>
                          <span class="gl-code-description-text">
                            <span class="gl-code">{{ v.glcode_detail.code }}</span>
                            <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                          </span>
                        </template>
                        <template v-else>
                          <div class="d-flex align-center justify-space-between">
                            <span class="gl-code-description-text">
                              <span class="gl-code" :class="{ 'gl-priority-text': v.glcode_detail && v.glcode_detail.priority === 1 }">{{ v.glcode_detail.code }}</span>
                              <span class="gl-description" :class="{ 'gl-priority-text': v.glcode_detail && v.glcode_detail.priority === 1 }">- {{ v.glcode_detail.name }}</span>
                            </span>
                            <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && v.sl_enabled">
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="sl-drill-indicator d-inline-flex align-center" data-testid="ru-data-table__sl-drill-indicator">
                                  <img src="../../../../public/img/icons/DrillDown.svg" alt="Drill Down" class="sl-drill-icon" />
                                </span>
                              </template>
                              <span>Drill Down</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </div>
                    </td>
                    <!-- Status cell - moved after GL Code & Description -->
                    <td class="text-left" style="white-space: nowrap;" data-testid="ru-data-table__status-cell">
                      <template v-if="!v.ignorecommentary">
                        <StatusIndicator
                          :variant="getCommentaryStatusVariant(v)"
                          :custom-label="getCommentaryStatusLabel(v)"
                          size="sm"
                        />
                      </template>
                      <template v-else>
                        <span class="text--disabled">--</span>
                      </template>
                    </td>
                    <td class="text-right" style="min-width: 140px;" data-testid="ru-data-table__actual-amount-cell">
                      {{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showProformaColumns" class="text-right" style="min-width: 140px;" data-testid="ru-data-table__proforma-amount-cell">
                      {{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showProformaColumns" data-testid="ru-data-table__proforma-flags-cell">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="l_c_m_c_pro" data-testid="ru-data-table__flag-proforma-local-control">mdi-circle</v-icon>
                            </template>
                            <span>{{ (local_controls_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="l_m_m_c_pro" data-testid="ru-data-table__flag-proforma-local-management">mdi-circle</v-icon>
                            </template>
                            <span>{{ (local_management_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="r_c_m_c_pro" data-testid="ru-data-table__flag-proforma-regional-control">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ (regional_controls_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="r_m_m_c_pro" data-testid="ru-data-table__flag-proforma-regional-management">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ (regional_management_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td v-if="showProformaColumns" class="" data-testid="ru-data-table__proforma-variance-amt-cell">
                      <div class="d-flex align-center justify-end">
                        <div :class="['ml-2', v.varianceamount1 > 0 ? '' : v.varianceamount1 < 0 ? '' : 'text-right']">
                          <span>{{$nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true)}}</span>
                      </div>
                      </div>
                    </td>
                    <td v-if="showProformaColumns" :class="((v.varianceamount1 > 0) ? '' : (( v.varianceamount1 < 0 ) ? '' : '')) + ' text-right'" data-testid="ru-data-table__proforma-variance-pct-cell">
                      <span>{{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false,true)}}{{ ((v.variancepercent1 !== 0)?'%':'')}}</span>
                    </td>
                    <td v-if="showForecastColumns" class="text-right" style="min-width: 140px;" data-testid="ru-data-table__forecast-amount-cell">
                      {{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showForecastColumns" data-testid="ru-data-table__forecast-flags-cell">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="l_c_m_c_fore" data-testid="ru-data-table__flag-forecast-local-control">mdi-circle</v-icon>
                            </template>
                              <span>{{ (local_controls_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                          <v-spacer />
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="l_m_m_c_fore" data-testid="ru-data-table__flag-forecast-local-management">mdi-circle</v-icon>
                            </template>
                              <span>{{ (local_management_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="r_c_m_c_fore" data-testid="ru-data-table__flag-forecast-regional-control">mdi-record-circle-outline</v-icon>
                            </template>
                              <span>{{ (regional_controls_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                          <v-spacer />
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="r_m_m_c_fore" data-testid="ru-data-table__flag-forecast-regional-management">mdi-record-circle-outline</v-icon>
                            </template>
                              <span>{{ (regional_management_label + ' Materiality crossed')  }}</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td v-if="showForecastColumns" data-testid="ru-data-table__forecast-variance-amt-cell">
                      <div class="d-flex align-center justtify-end">
                        <div :class="['ml-2', v.varianceamount2 > 0 ? '' : v.varianceamount2 < 0 ? '' : 'text-right']">
                          <span>{{$nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true)}}</span>
                      </div>
                      </div>
                    </td>
                    <td v-if="showForecastColumns" :class="((v.varianceamount2 > 0) ? '' : ((v.varianceamount2 < 0) ? '' : '')) + ' text-right'" data-testid="ru-data-table__forecast-variance-pct-cell">
                      <span>{{ $nova.formatCurrency((v.variancepercent2).toFixed(1), '', false, true)}}{{ ((v.variancepercent2 !== 0)?'%':'')}}</span>
                    </td>
                  </template>
                </tr>

                <!-- Ungrouped Items Accordion Header -->
                <tr v-if="ungroupedGLItems && ungroupedGLItems.length > 0" 
                  class="ungrouped-accordion-header cursor-pointer" 
                  role="button"
                  tabindex="0"
                  :aria-expanded="ungroupedAccordionExpanded.toString()"
                  @click.stop="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
                  @keydown.enter.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
                  @keydown.space.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
                  data-testid="ru-data-table__ungrouped-accordion-header"
                >
                  <td :colspan="getListViewColspan" class="pa-2">
                    <div class="d-flex align-center">
                      <v-icon small class="mr-2">{{ ungroupedAccordionExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                      <span class="font-weight-bold text-subtitle-2">Ungrouped Items</span>
                      <v-chip x-small class="ml-2" color="grey lighten-2">{{ ungroupedGLItems.length }}</v-chip>
                    </div>
                  </td>
                </tr>
                <!-- Ungrouped Items Rows (same structure as regular GL rows) -->
                <template v-if="ungroupedAccordionExpanded && ungroupedGLItems && ungroupedGLItems.length > 0">
                  <tr v-for="v in ungroupedGLItems" 
                    :key="'ungrouped-' + v._id"
                    class="tree-table cursor-pointer ungrouped-item-row"
                    :class="{ 'clickable-gl-row': true }"
                    data-testid="ru-data-table__ungrouped-row"
                    @click="handleRowClick(v, $event)"
                  >
                    <td v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                      <div class="tree-node-wrapper">
                        <div class="tree-expand-icon">
                          <span class="expand-icon">
                            <v-icon small class="leaf-node-icon" color="primary" data-testid="ru-data-table__ungrouped-leaf-icon">mdi-checkbox-blank</v-icon>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="pl-0 pr-0" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3">
                      <v-checkbox multiple v-model="localMultiselectdata" :value="v._id" name="select-gl-code" hide-details dense class="pa-0 ma-0 navigation-checkbox-cycle" data-test="child-checkbox"></v-checkbox>
                    </td>
                    <td v-if="toggleview === 3">{{ getRuCode(v.cycle) }}</td>
                    <td v-if="toggleview === 3">{{ getRuName(v.cycle) }}</td>
                    <td class="gl-code-description-cell">
                      <div class="">
                        <div class="d-flex align-center justify-space-between">
                          <span class="gl-code-description-text">
                            <span class="gl-code" :class="{ 'gl-priority-text': v.glcode_detail && v.glcode_detail.priority === 1 }">{{ v.glcode_detail.code }}</span>
                            <span class="gl-description" :class="{ 'gl-priority-text': v.glcode_detail && v.glcode_detail.priority === 1 }">- {{ v.glcode_detail.name }}</span>
                          </span>
                          <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && v.sl_enabled">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on" class="sl-drill-indicator d-inline-flex align-center">
                                <img src="../../../../public/img/icons/DrillDown.svg" alt="Drill Down" class="sl-drill-icon" />
                              </span>
                            </template>
                            <span>Drill Down</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td class="text-left" style="white-space: nowrap;">
                      <template v-if="!v.ignorecommentary">
                        <StatusIndicator
                          :variant="getCommentaryStatusVariant(v)"
                          :custom-label="getCommentaryStatusLabel(v)"
                          size="sm"
                        />
                      </template>
                      <template v-else>
                        <span class="text--disabled">--</span>
                      </template>
                    </td>
                    <td class="text-right" style="min-width: 140px;">
                      {{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showProformaColumns" class="text-right" style="min-width: 140px;">
                      {{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showProformaColumns">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag">mdi-circle</v-icon>
                            </template>
                            <span>{{ local_controls_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag">mdi-circle</v-icon>
                            </template>
                            <span>{{ local_management_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ regional_controls_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ regional_management_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td v-if="showProformaColumns" class="">
                      <div class="d-flex align-center justify-end">
                        <div :class="['ml-2', v.varianceamount1 > 0 ? '' : v.varianceamount1 < 0 ? '' : 'text-right']">
                          <span>{{ $nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true) }}</span>
                        </div>
                      </div>
                    </td>
                    <td v-if="showProformaColumns" :class="((v.varianceamount1 > 0) ? '' : ((v.varianceamount1 < 0) ? '' : '')) + ' text-right'">
                      <span>{{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) }}{{ v.variancepercent1 !== 0 ? '%' : '' }}</span>
                    </td>
                    <td v-if="showForecastColumns" class="text-right" style="min-width: 140px;">
                      {{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}
                    </td>
                    <td v-if="showForecastColumns">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag">mdi-circle</v-icon>
                            </template>
                            <span>{{ local_controls_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                          <v-spacer />
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag">mdi-circle</v-icon>
                            </template>
                            <span>{{ local_management_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex flex-column">
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ regional_controls_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                          <v-spacer />
                          <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management_regional">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag">mdi-record-circle-outline</v-icon>
                            </template>
                            <span>{{ regional_management_label + ' Materiality crossed' }}</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td v-if="showForecastColumns">
                      <div class="d-flex align-center justify-end">
                        <div :class="['ml-2', v.varianceamount2 > 0 ? '' : v.varianceamount2 < 0 ? '' : 'text-right']">
                          <span>{{ $nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true) }}</span>
                        </div>
                      </div>
                    </td>
                    <td v-if="showForecastColumns" :class="((v.varianceamount2 > 0) ? '' : ((v.varianceamount2 < 0) ? '' : '')) + ' text-right'">
                      <span>{{ $nova.formatCurrency((v.variancepercent2).toFixed(1), '', false, true) }}{{ v.variancepercent2 !== 0 ? '%' : '' }}</span>
                    </td>
                  </tr>
                </template>

              </tbody>
              <tbody v-else data-testid="ru-data-table__revenue-body">
                <!-- Empty state when no filtered results -->
                <tr v-if="displayItems.length === 0 && !(ungroupedGLItems && ungroupedGLItems.length > 0)" data-testid="ru-data-table__revenue-empty-row">
                  <td :colspan="getListViewColspan" class="text-center pa-6">
                    <NoDataState
                      class="py-6 text--secondary"
                      data-testid="ru-data-table__revenue-empty-state"
                      :title="varianceUiCopy.FILTER_NO_DATA_TITLE"
                      :description="varianceUiCopy.NO_FILTER_RESULTS_DESCRIPTION"
                      :icon="varianceUiCopy.NO_FILTER_RESULTS_ICON"
                      :icon-size="varianceUiCopy.NO_FILTER_RESULTS_ICON_SIZE"
                    />
                  </td>
                </tr>
                <tr
                  v-for="v in displayItems"
                  :key="v._id"
                  class="tree-table cursor-pointer"
                  :class="{ 'sl-grouped-header-row': v.__type === 'header' }"
                  v-intersect.quiet="getIntersectHandler(v)"
                  data-testid="ru-data-table__revenue-row"
                  @click="handleRevenueRowClick(v, $event)"
                >
                  <td
                    v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3"
                    class="pl-0 pr-0"
                    data-testid="ru-data-table__selection-cell"
                  >
                    <template v-if="v.__code === 'NA'">
                      <span></span>
                    </template>
                    <template v-else>
                      <v-checkbox
                        v-if="!v.hide_action"
                        multiple
                        v-model="localMultiselectdata"
                        :value="v._id"
                        name="select-client"
                        hide-details
                        dense
                        class="pa-0 ma-0 navigation-checkbox-cycle"
                        :data-test="v.__type === 'header' ? 'parent-checkbox' : 'child-checkbox'"
                      ></v-checkbox>
                    </template>
                  </td>
                  <td
                    class="client-code-cell"
                    data-testid="ru-data-table__client-code-cell"
                  >
                    <div class="d-flex">
                      <div :class="'padding-level-' + v.level" class="mr-2">
                        <span
                          v-if="hasChildren(v) && shouldShowExpandIcon"
                          class="expand-icon"
                          @click.stop="forwardToggleExpand(v)"
                        >
                          <v-icon>
                            {{ isExpanded(v) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                          </v-icon>
                        </span>
                        <span v-else class="no-children-spacer"></span>
                      </div>
                      <span class="gl-code">{{ v.glcode_detail?.code || 'NA' }}</span>
                    </div>
                  </td>
                  <td class="client-name-cell" data-testid="ru-data-table__client-name-cell">
                    <span class="gl-description">{{ v.glcode_detail?.name || '-' }}</span>
                  </td>
                  <td class="text-left" style="white-space: nowrap;" data-testid="ru-data-table__status-cell">
                    <template v-if="!v.ignorecommentary">
                      <StatusIndicator
                        :variant="getCommentaryStatusVariant(v)"
                        :custom-label="getCommentaryStatusLabel(v)"
                        size="sm"
                      />
                    </template>
                    <template v-else>
                      <span class="text--disabled">--</span>
                    </template>
                  </td>
                  <td class="text-right" data-testid="ru-data-table__actual-amount-cell">
                    {{ $nova.formatCurrency((v.amount1 || 0).toFixed(1), '', false, true) }}
                  </td>
                  <template v-if="showProformaColumns">
                  <td class="text-right" data-testid="ru-data-table__proforma-amount-cell">
                    {{ $nova.formatCurrency((v.amount2 || 0).toFixed(1), '', false, true) }}
                  </td>
                  <td data-testid="ru-data-table__proforma-flags-cell" class="flags-cell">
                    <div class="d-flex align-center justify-center">
                      <div class="d-flex flex-column">
                        <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag" data-testid="ru-data-table__proforma-control-flag-local">mdi-circle</v-icon>
                          </template>
                          <span>{{ local_controls_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag" data-testid="ru-data-table__proforma-management-flag-local">mdi-circle</v-icon>
                          </template>
                          <span>{{ local_management_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                      <div class="d-flex flex-column">
                        <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag" data-testid="ru-data-table__proforma-control-flag-regional">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ regional_controls_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag" data-testid="ru-data-table__proforma-management-flag-regional">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ regional_management_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </td>
                  <td class="text-right" data-testid="ru-data-table__proforma-variance-cell">
                    <span :class="v.varianceamount1 > 0 ? '' : v.varianceamount1 < 0 ? '' : 'text-right'">
                      {{ $nova.formatCurrency((v.varianceamount1 || 0).toFixed(1), '', false, true) }}
                    </span>
                  </td>
                  <td class="text-right" data-testid="ru-data-table__proforma-variance-pct-cell">
                    <span :class="v?.varianceamount1 > 0 ? '' : v?.varianceamount1 < 0 ? '' : 'text-right'">
                      {{ $nova.formatCurrency((v.variancepercent1 || 0).toFixed(1), '', false, true) }}{{ v.variancepercent1 ? '%' : '' }}
                    </span>
                  </td>
                  <td class="comment-cell cursor-pointer" data-testid="ru-data-table__proforma-comments-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                    <div v-if="isActualJVCommentaryValidForLocal(v)" class="noTransform" style="width: 250px;">
                      <v-chip small density="comfortable">JV:</v-chip>
                      <span class="noTransform">{{ Object.entries(v.jv_commentary1 || {}).map(function(entry){return entry[0] + ': ' + entry[1];}).join(', ') }}</span>
                    </div>
                    <div v-else-if="hasProformaLocalCommentary(v)" class="noTransform" style="width: 250px;">
                      <div class="noTransform" v-html="localCommentary1Count(v)"></div>
                    </div>
                    <div v-if="isActualJVCommentaryValidForRegional(v)" class="noTransform mt-2">
                      <v-chip small density="comfortable">JV:</v-chip>
                      <span class="noTransform">{{ Object.entries(v.jv_commentary1 || {}).map(function(entry){return entry[0] + ': ' + entry[1];}).join(', ') }}</span>
                    </div>
                    <div v-else-if="hasProformaRegionalCommentary(v)" class="noTransform mt-2">
                      <div class="noTransform" v-html="regionalCommentary1Count(v)"></div>
                    </div>
                    <div v-if="!hasProformaCommentary(v)" class="text--disabled">--</div>
                  </td>
                  </template>
                  <template v-if="showForecastColumns">
                  <td class="text-right" data-testid="ru-data-table__forecast-amount-cell">
                    {{ $nova.formatCurrency((v.amount3 || 0).toFixed(1), '', false, true) }}
                  </td>
                  <td data-testid="ru-data-table__forecast-flags-cell" class="flags-cell">
                    <div class="d-flex align-center justify-center">
                      <div class="d-flex flex-column">
                        <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag" data-testid="ru-data-table__forecast-control-flag-local">mdi-circle</v-icon>
                          </template>
                          <span>{{ local_controls_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag" data-testid="ru-data-table__forecast-management-flag-local">mdi-circle</v-icon>
                          </template>
                          <span>{{ local_management_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                      <div class="d-flex flex-column">
                        <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="error--text controls_flag" data-testid="ru-data-table__forecast-control-flag-regional">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ regional_controls_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="blue--text controls_flag" data-testid="ru-data-table__forecast-management-flag-regional">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ regional_management_label + ' Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </td>
                  <td class="text-right" data-testid="ru-data-table__forecast-variance-cell">
                    <span :class="v.varianceamount2 > 0 ? '' : v.varianceamount2 < 0 ? '' : 'text-right'">
                      {{ $nova.formatCurrency((v.varianceamount2 || 0).toFixed(1), '', false, true) }}
                    </span>
                  </td>
                  <td class="text-right" data-testid="ru-data-table__forecast-variance-pct-cell">
                    <span :class="v?.varianceamount2 > 0 ? '' : v?.varianceamount2 < 0 ? '' : 'text-right'">
                      {{ $nova.formatCurrency((v?.variancepercent2 || 0).toFixed(1), '', false, true) }}{{ v?.variancepercent2 ? '%' : '' }}
                    </span>
                  </td>
                  <td class="comment-cell cursor-pointer" data-testid="ru-data-table__forecast-comments-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                    <div v-if="isForecastJVCommentaryValidForLocal(v)" class="noTransform" style="width: 250px;">
                      <v-chip small density="comfortable">JV:</v-chip>
                      <span class="noTransform">{{ Object.entries(v.jv_commentary2 || {}).map(function(entry){return entry[0] + ': ' + entry[1];}).join(', ') }}</span>
                    </div>
                    <div v-else-if="hasForecastLocalCommentary(v)" class="noTransform" style="width: 250px;">
                      <div class="noTransform" v-html="localCommentary2Count(v)"></div>
                    </div>
                    <div v-if="isForecastJVCommentaryValidForRegional(v)" class="noTransform mt-2">
                      <v-chip small density="comfortable">JV:</v-chip>
                      <span class="noTransform">{{ Object.entries(v.jv_commentary2 || {}).map(function(entry){return entry[0] + ': ' + entry[1];}).join(', ') }}</span>
                    </div>
                    <div v-else-if="hasForecastRegionalCommentary(v)" class="noTransform mt-2">
                      <div class="noTransform" v-html="regionalCommentary2Count(v)"></div>
                    </div>
                    <div v-if="!hasForecastCommentary(v)" class="text--disabled">--</div>
                  </td>
                  </template>
                  <!-- Action Column for SL Breakup -->
                  <td class="text-center" data-testid="ru-data-table__action-cell ">
                    <div class="d-flex justify-center align-center action-icons">
                      <template v-if="!(v.hide_action)">
                      <!-- Request Local Commentary Button -->
                      <v-tooltip v-if="(isapprover) && [3,4,7,8,9].indexOf(v.__stage) > -1 && (ispendinglocalruapproval || (!ispendinglocalruapproval && !workflows.isregionalenabled))" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button :imageWidth="22" small @click.stop="forwardOpenSubmitDialog(v, 'requestlocal')" v-bind="attrs" v-on="on" name="request-commentary-local" icon-style :disabled="!workflows.islocalenabled" image="/img/icons/request-commentary.svg" image-alt="Request Local Commentary" data-testid="ru-data-table__action-request-local-btn" />
                        </template>
                        <span>Request Commentary</span>
                      </v-tooltip>
                      <!-- Request Regional Commentary Button -->
                      <v-tooltip v-if="(isregionalapprover) && [3,4,7,8,9].indexOf(v.__stage) > -1" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button :imageWidth="22" small @click.stop="forwardOpenSubmitDialog(v, 'requestregional')" v-bind="attrs" v-on="on" name="request-commentary-regional" icon-style :disabled="!workflows.isregionalenabled" image="/img/icons/request-commentary.svg" image-alt="Request Regional Commentary" data-testid="ru-data-table__action-request-regional-btn" />
                        </template>
                        <span>Request Commentary</span>
                      </v-tooltip>
                      <!-- Add Local Commentary Button -->
                      <v-tooltip v-if="(v.__myaction === 'localadd' || (v.__myaction === 'localvoluntary' && (ispendinglocalruapproval || ispendingregionalruapproval))) && v.__stage !== 9" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button @click.stop="forwardOpenSubmitDialog(v, 'addlocal')" v-bind="attrs" v-on="on" name="add-local-commentary" icon-style small :disabled="!workflows.islocalenabled" image="/img/icons/AddIcon.svg" image-alt="Add Local Commentary" data-testid="ru-data-table__action-add-local-btn" />
                        </template>
                        <span>Add {{ commentary_local_key_label }} Commentary</span>
                      </v-tooltip>
                      <!-- Add Regional Commentary Button -->
                      <v-tooltip v-if="(v.__myaction === 'regionaladd') && v.__stage !== 9" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button @click.stop="forwardOpenSubmitDialog(v, 'addregional')" v-bind="attrs" v-on="on" name="add-regional-commentary" icon-style :disabled="!workflows.isregionalenabled" image="/img/icons/AddIcon.svg" image-alt="Add Regional Commentary" data-testid="ru-data-table__action-add-regional-btn" />
                        </template>
                        <span>Add {{ commentary_regional_key_label }} Commentary</span>
                      </v-tooltip>
                      <!-- Approve Local Commentary Button -->
                      <v-tooltip v-if="v.__myaction === 'localapprove'" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button @click.stop="forwardOpenSubmitDialog(v, 'approvelocal', true)" v-bind="attrs" v-on="on" name="approve-local-commentary" icon="mdi-check-circle" data-testid="ru-data-table__action-approve-local-btn" />
                        </template>
                        <span>{{ commentary_local_key_label }} Approve/Reject</span>
                      </v-tooltip>
                      <!-- Approve Regional Commentary Button -->
                      <v-tooltip v-if="v.__myaction === 'regionalapprove' || (toggleview === 3 && v.stage_regional !== 2)" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button @click.stop="forwardOpenSubmitDialog(v, 'approveregional')" v-bind="attrs" v-on="on" name="approve-regional-commentary" icon="mdi-check-circle-outline" data-testid="ru-data-table__action-approve-regional-btn" />
                        </template>
                        <span>{{ commentary_regional_key_label }} Approve/Reject</span>
                      </v-tooltip>
                      <!-- View Button -->
                      <v-tooltip v-if="v.__myaction === 'view' || v.__myaction === 'localrequest' || v.__myaction === 'regionalrequest'" bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <base-button small @click.stop="forwardOpenSubmitDialog(v, 'view', false)" v-bind="attrs" v-on="on" name="view-commentary" icon-style image="/img/icons/EyeIcons.svg"  image-alt="View Details" data-testid="ru-data-table__action-view-btn" />
                        </template>
                        <span>View Details</span>
                      </v-tooltip>
                      <!-- Conversation -->
                      <div v-if="workflowtext.length !== 8">
                        <lb-conversation heading="Conversation" width="600" :recurring="false" :recurringText="''" :closed="cyclestage === 1 || isviewonly" @markread="$emit('mark-conversation-read', v)" :highlight="!v.conversation_read" :notify="!v.conversation_read" :getapi="getConversationUrl(v, 'getconversation')" :sendapi="getConversationUrl(v, 'addconversation')" :readapi="getConversationUrl(v, 'markreadconversation')" :showprofile="false" :filter="{ reporting_type: reportingType }" />
                      </div>
                      <div v-else>
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button small name="conversations" v-bind="attrs" v-on="on" icon="mdi-comment-text-multiple" data-testid="ru-data-table__action-conversations-btn" />
                          </template>
                          <span>{{ workflowsDisabledMessage }}</span>
                        </v-tooltip>
                      </div>
                      <!-- Activity Log -->
                      <lb-activitylog :config="activitylogconfiggl" :url="getActivityLogUrl(v)" :filter="{ reporting_type: reportingType }" :reporting-type="reportingType" />
                      </template>
                    </div>
                  </td>
                </tr>
                <!-- Lazy Load Trigger Row - triggers loading more rows when visible -->
                <tr v-if="hasMoreRows" v-intersect="onLazyLoadTrigger" class="lazy-load-trigger" data-testid="ru-data-table__lazy-load-trigger">
                  <td :colspan="getListViewColspan" class="text-center pa-4">
                    <v-progress-circular indeterminate size="20" width="2" color="primary" />
                    <span class="ml-2 text--secondary">Loading more...</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <template v-if="filteredcommentarydata && filteredcommentarydata.length === 0 && !isReportingUnitClicked">
        <template v-if="$attrs.loading">
          <div class="pa-5 text-center" data-testid="ru-data-table__loading-row">
            <span class="dots-loader">Please wait as we load your data<span>.</span><span>.</span><span>.</span></span>
          </div>
        </template>
      </template>
    </div>
    <div v-else key="commentary-view" class="table-responsive-wrapper">
      <!-- Proforma Commentary Table - Shows when ONLY Proforma is selected -->
      <v-simple-table class="main-table-style " v-if="cycletypeReadview === 'Proforma'">
        <thead class="tableHeaderBg">
          <tr>
            <th scope="navigation" class="align-center text-left" v-if="!isRevenueBreakup && !isGlNavigationEnabled">Navigation <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="forwardToggleExpandAll()" class="ml-2" data-testid="ru-data-table__proforma-expand-collapse-all-btn">
                    {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                  </v-icon>
                </template>
                <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
              </v-tooltip>
            </th>
            <th scope="gl_code_description" class="text-left gl-code-description-column" style="width: 20%; white-space: nowrap;">
              {{ isRevenueBreakup ? 'Client Code & Name' : $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') + ' & Description' }}
              <template v-if="!isRevenueBreakup">
                <v-btn class="shadow-off ml-2" name="filter-gl-code" icon @click="$emit('open-custom-filters-dialog')" data-testid="ru-data-table__proforma-filter-btn">
                  <img src="../../../../public/img/icons/FilterIcon.svg" alt="Menu Filter Icon" class="filter-icon" />
                </v-btn>
              </template>
            </th>
            <th scope="status" class="text-left">Status
              <StatusFilterMenu
                :selectedfilter="selectedfilter"
                @update:selected-filter="$emit('update:selected-filter', $event)"
              />
            </th>
            <th scope="forecast" class="text-right">
              {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}}
            </th>
            <th scope="forecast_vs_proforma" class="text-left">
              {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}} Vs {{ proformaLabel }}
            </th>
            <th scope="local_commentary" class="text-left">{{commentary_local_key_label +' Commentary' }}</th>
            <th scope="regional_commentary" class="text-left">{{commentary_regional_key_label +' Commentary' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="v in displayItems" :key="v._id" :style="{fontWeight: v.level === 0 ? 'bold' : 'normal'}" class="tree-table" v-intersect.quiet="(entries) => handleIntersectEntry(entries, v.__index)">
            <template v-if="v.__code === 'NA'">
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <!-- Tree connector lines for hierarchy -->
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment reset-expander"
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__proforma-expand-icon-na">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__proforma-leaf-icon-na">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <!-- Line extending from expanded parent to children -->
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <!-- Combined GL Code & Description column for NA rows -->
              <td class="gl-code-description-cell" colspan="12">
                <span class="gl-code-description-text">
                  <span class="gl-code">NA</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
            </template>
            <template v-else>
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <!-- Tree connector lines for hierarchy -->
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment reset-expander"
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__proforma-expand-icon-gl">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__proforma-leaf-icon-gl">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <!-- Line extending from expanded parent to children -->
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <!-- Combined GL Code & Description column -->
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <!-- Status cell -->
              <td class="status-cell-commentary" data-testid="ru-data-table__commentary-status-cell">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator
                    :variant="getCommentaryStatusVariant(v)"
                    :custom-label="getCommentaryStatusLabel(v)"
                    size="sm"
                  />
                </template>
                <template v-else>
                  <span class="text--disabled">--</span>
                </template>
              </td>
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <!-- Comparison column: Actual vs Proforma -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ proformaLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) }}{{ v.variancepercent1 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                  <div v-if="isActualJVCommentaryValidForLocal(v)">
                    <v-chip small density="comfortable">JV:</v-chip>
                    <span class="noTransform">{{Object.entries(v.jv_commentary1).map(([key, value]) => key + ': ' + value).join(', ')}}</span>
                  </div>
                  <div class="noTransform" v-else-if="v.commentary1 && v.commentary1 !== '' && !v.ignorecommentary">
                  <div class="noTransform" v-html="localCommentary1Count(v)"></div>
                  </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                  <div v-if="v.regionalcommentary1">
                  <div class="noTransform" v-html="regionalCommentary1Count(v)"></div>
                  </div>
              </td>
            </template>
          </tr>
          <!-- Ungrouped Items Accordion (Proforma Commentary) -->
          <tr v-if="ungroupedGLItems && ungroupedGLItems.length > 0" 
            class="ungrouped-accordion-header cursor-pointer" 
            role="button"
            tabindex="0"
            :aria-expanded="ungroupedAccordionExpanded.toString()"
            @click.stop="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.enter.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.space.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
          >
            <td :colspan="(!isRevenueBreakup && !isGlNavigationEnabled) ? 7 : 6" class="pa-2">
              <div class="d-flex align-center">
                <v-icon small class="mr-2">{{ ungroupedAccordionExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                <span class="font-weight-bold text-subtitle-2">Ungrouped Items</span>
                <v-chip x-small class="ml-2" color="grey lighten-2">{{ ungroupedGLItems.length }}</v-chip>
              </div>
            </td>
          </tr>
          <template v-if="ungroupedAccordionExpanded && ungroupedGLItems && ungroupedGLItems.length > 0">
            <tr v-for="v in ungroupedGLItems" :key="'ungrouped-pro-' + v._id" class="tree-table ungrouped-item-row cursor-pointer" @click="handleRowClick(v, $event)">
              <td v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <div class="tree-expand-icon">
                    <span class="expand-icon">
                      <v-icon small class="leaf-node-icon">mdi-checkbox-blank-outline</v-icon>
                    </span>
                  </div>
                </div>
              </td>
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <td class="status-cell-commentary">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator :variant="getCommentaryStatusVariant(v)" :custom-label="getCommentaryStatusLabel(v)" size="sm" />
                </template>
                <template v-else><span class="text--disabled">--</span></template>
              </td>
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ proformaLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) }}{{ v.variancepercent1 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div v-if="isActualJVCommentaryValidForLocal(v)">
                  <v-chip small density="comfortable">JV:</v-chip>
                  <span class="noTransform">{{Object.entries(v.jv_commentary1).map(([key, value]) => key + ': ' + value).join(', ')}}</span>
                </div>
                <div class="noTransform" v-else-if="v.commentary1 && v.commentary1 !== '' && !v.ignorecommentary">
                  <div class="noTransform" v-html="localCommentary1Count(v)"></div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div v-if="v.regionalcommentary1">
                  <div class="noTransform" v-html="regionalCommentary1Count(v)"></div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
      <!-- Forecast Commentary Table - Shows when ONLY Forecast is selected -->
      <v-simple-table class="main-table-style" fixed-header v-if="cycletypeReadview === 'Forecast'">
        <thead class="tableHeaderBg">
          <tr>
            <th scope="navigation" class="align-center text-left" v-if="!isRevenueBreakup && !isGlNavigationEnabled">Navigation <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="forwardToggleExpandAll()" class="ml-2" data-testid="ru-data-table__forecast-expand-collapse-all-btn">
                    {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                  </v-icon>
                </template>
                <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
              </v-tooltip>
            </th>
            <th scope="gl_code_description" class="text-left gl-code-description-column" style="width: 20%; white-space: nowrap;">
              {{ isRevenueBreakup ? 'Client Code & Name' : $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') + ' & Description' }}
              <template v-if="!isRevenueBreakup">
                <v-btn class="shadow-off ml-2" name="filter-gl-code" icon @click="$emit('open-custom-filters-dialog')" data-testid="ru-data-table__forecast-filter-btn">
                  <img src="../../../../public/img/icons/FilterIcon.svg" alt="Menu Filter Icon" class="filter-icon" />
                </v-btn>
              </template>
            </th>
            <th scope="status" class="text-left">Status
              <StatusFilterMenu
                :selectedfilter="selectedfilter"
                @update:selected-filter="$emit('update:selected-filter', $event)"
              />
            </th>
            <th scope="forecast" class="text-right">
              {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}}
            </th>
            <th scope="forecast_vs_proforma" class="text-left">
               {{(cycletype==='Forecast')? forecastLabel : actualLabel}} Vs {{(cycletype==='Forecast')? 'Previous ' + forecastLabel : forecastLabel }}
            </th>
            <th scope="local_commentary" class="text-left">{{commentary_local_key_label + ' Commentary'}}</th>
            <th scope="regional_commentary" class="text-left">{{commentary_regional_key_label + ' Commentary'}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="v in displayItems" :key="v._id" :style="{ fontWeight: v.level === 0 ? 'bold' : 'normal'}" class="tree-table" v-intersect.quiet="(entries) => handleIntersectEntry(entries, v.__index)">
            <template v-if="v.__code === 'NA'">
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <!-- Tree connector lines for hierarchy -->
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment "
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__forecast-expand-icon-na">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__forecast-leaf-icon-na">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <!-- Line extending from expanded parent to children -->
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <!-- Combined GL Code & Description column for NA rows -->
              <td class="gl-code-description-cell" colspan="12">
                <span class="gl-code-description-text">
                  <span class="gl-code">NA</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
            </template>
            <template v-else>
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <!-- Tree connector lines for hierarchy -->
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment"
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__forecast-expand-icon-gl">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__forecast-leaf-icon-gl">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <!-- Line extending from expanded parent to children -->
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <!-- Combined GL Code & Description column -->
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <!-- Status cell -->
              <td class="status-cell-commentary" data-testid="ru-data-table__commentary-status-cell">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator
                    :variant="getCommentaryStatusVariant(v)"
                    :custom-label="getCommentaryStatusLabel(v)"
                    size="sm"
                  />
                </template>
                <template v-else>
                  <span class="text--disabled">--</span>
                </template>
              </td>
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <!-- Comparison column: Actual vs Forecast -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency(v.variancepercent2.toFixed(1), '', false, true) }}{{ v.variancepercent2 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                  <div  v-if="isForecastJVCommentaryValidForLocal(v)"> 
                    <v-chip small density="comfortable">JV:</v-chip>
                    <span class="noTransform">{{Object.entries(v.jv_commentary2).map(([key, value]) => key + ': ' + value).join(', ')}}</span>                 
                  </div>
                  <div class="noTransform" v-else-if="v.commentary2 && v.commentary2 !== '' && !v.ignorecommentary">
                  <div class="noTransform"  v-html="localCommentary2Count(v)"></div>
                  </div>
                
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                  <div v-if="v.regionalcommentary2">
                  <div v-html="regionalCommentary2Count(v)"></div>
                  </div>
              </td>
            </template>
          </tr>
          <!-- Ungrouped Items Accordion (Forecast Commentary) -->
          <tr v-if="ungroupedGLItems && ungroupedGLItems.length > 0" 
            class="ungrouped-accordion-header cursor-pointer" 
            role="button"
            tabindex="0"
            :aria-expanded="ungroupedAccordionExpanded.toString()"
            @click.stop="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.enter.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.space.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
          >
            <td :colspan="(!isRevenueBreakup && !isGlNavigationEnabled) ? 7 : 6" class="pa-2">
              <div class="d-flex align-center">
                <v-icon small class="mr-2">{{ ungroupedAccordionExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                <span class="font-weight-bold text-subtitle-2">Ungrouped Items</span>
                <v-chip x-small class="ml-2" color="grey lighten-2">{{ ungroupedGLItems.length }}</v-chip>
              </div>
            </td>
          </tr>
          <template v-if="ungroupedAccordionExpanded && ungroupedGLItems && ungroupedGLItems.length > 0">
            <tr v-for="v in ungroupedGLItems" :key="'ungrouped-fore-' + v._id" class="tree-table ungrouped-item-row cursor-pointer" @click="handleRowClick(v, $event)">
              <td v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <div class="tree-expand-icon">
                    <span class="expand-icon">
                      <v-icon small class="leaf-node-icon">mdi-checkbox-blank-outline</v-icon>
                    </span>
                  </div>
                </div>
              </td>
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <td class="status-cell-commentary">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator :variant="getCommentaryStatusVariant(v)" :custom-label="getCommentaryStatusLabel(v)" size="sm" />
                </template>
                <template v-else><span class="text--disabled">--</span></template>
              </td>
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency(v.variancepercent2.toFixed(1), '', false, true) }}{{ v.variancepercent2 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div v-if="isForecastJVCommentaryValidForLocal(v)">
                  <v-chip small density="comfortable">JV:</v-chip>
                  <span class="noTransform">{{Object.entries(v.jv_commentary2).map(([key, value]) => key + ': ' + value).join(', ')}}</span>
                </div>
                <div class="noTransform" v-else-if="v.commentary2 && v.commentary2 !== '' && !v.ignorecommentary">
                  <div class="noTransform" v-html="localCommentary2Count(v)"></div>
                </div>
              </td>
              <td class="commentary-cell" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div v-if="hasForecastRegionalCommentary(v)">
                  <div v-html="regionalCommentary2Count(v)"></div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
      <!-- Combined Commentary Table - Shows when All is selected -->
      <v-simple-table class="main-table-style" fixed-header v-if="cycletypeReadview === 'All'">
        <thead class="tableHeaderBg">
          <tr>
            <th scope="navigation" class="align-center text-left" v-if="!isRevenueBreakup && !isGlNavigationEnabled">Navigation <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="forwardToggleExpandAll()" class="ml-2" data-testid="ru-data-table__all-expand-collapse-all-btn">
                    {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                  </v-icon>
                </template>
                <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
              </v-tooltip>
            </th>
            <th scope="gl_code_description" class="text-left gl-code-description-column" style="width: 15%; white-space: nowrap;">
              {{ isRevenueBreakup ? 'Client Code & Name' : $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') + ' & Description' }}
              <template v-if="!isRevenueBreakup">
                <v-btn class="shadow-off ml-2" name="filter-gl-code" icon @click="$emit('open-custom-filters-dialog')" data-testid="ru-data-table__all-filter-btn">
                  <img src="../../../../public/img/icons/FilterIcon.svg" alt="Menu Filter Icon" class="filter-icon" />
                </v-btn>
              </template>
            </th>
            <th scope="status" class="text-left">Status
              <StatusFilterMenu
                :selectedfilter="selectedfilter"
                @update:selected-filter="$emit('update:selected-filter', $event)"
              />
            </th>
            <th scope="forecast" class="text-right">
              {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}}
            </th>
            <!-- Proforma Comparison Column -->
            <th scope="forecast_vs_proforma" class="text-left">
              {{ (cycletype === 'Forecast') ? forecastLabel : actualLabel}} Vs {{ proformaLabel }}
            </th>
            <!-- Forecast Comparison Column -->
            <th scope="forecast_vs_previous" class="text-left">
{{ (cycletype === 'Forecast') ? forecastLabel : actualLabel }} Vs {{ (cycletype === 'Forecast') ? 'Previous' + ' ' + forecastLabel : forecastLabel }}
            </th>
            <th scope="local_commentary" class="text-left">{{commentary_local_key_label + ' Commentary'}}</th>
            <th scope="regional_commentary" class="text-left">{{commentary_regional_key_label + ' Commentary'}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="v in displayItems" :key="v._id" :style="{ fontWeight: v.level === 0 ? 'bold' : 'normal'}" class="tree-table" v-intersect.quiet="(entries) => handleIntersectEntry(entries, v.__index)">
            <template v-if="v.__code === 'NA'">
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment"
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__all-expand-icon-na">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__all-leaf-icon-na">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <td class="gl-code-description-cell" colspan="12">
                <span class="gl-code-description-text">
                  <span class="gl-code">NA</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
            </template>
            <template v-else>
              <td @click="forwardToggleExpand(v)" v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <div class="tree-connectors" v-if="v.level > 0 && shouldShowTreeConnectors">
                    <template v-for="(connector, idx) in getTreeConnectors(v, displayItems.indexOf(v))">
                      <div 
                        :key="'connector-' + idx"
                        class="tree-connector-segment"
                        :class="[
                          'tree-level-' + connector.level,
                          {
                            'has-vertical-line': connector.showVerticalLine || connector.isCurrentLevel,
                            'is-current-level': connector.isCurrentLevel,
                            'is-last-child': connector.isLastChild,
                            'is-first-child': connector.isFirstChild,
                            'is-inverted': connector.isInverted
                          }
                        ]"
                        :style="{ left: ((connector.level - 1) * 20 + 10) + 'px' }"
                      >
                        <div 
                          class="vertical-line" 
                          v-if="connector.showVerticalLine || connector.isCurrentLevel"
                          :class="{ 
                            'half-height': connector.isCurrentLevel && ((connector.isLastChild && !connector.isInverted) || (connector.isFirstChild && connector.isInverted)),
                            'half-height-top': connector.isCurrentLevel && connector.isInverted && connector.isLastChild
                          }"
                        ></div>
                        <div class="horizontal-branch" v-if="connector.isCurrentLevel"></div>
                      </div>
                    </template>
                  </div>
                  <div class="tree-expand-icon" :style="{ marginLeft: (v.level * 20) + 'px' }">
                    <span class="expand-icon">
                      <template v-if="hasChildren(v) && !isFilterSet">
                        <v-icon small data-testid="ru-data-table__all-expand-icon-gl">{{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small class="leaf-node-icon" data-testid="ru-data-table__all-leaf-icon-gl">mdi-checkbox-blank-outline</v-icon>
                      </template>
                    </span>
                  </div>
                  <div v-if="isExpanded(v) && hasChildren(v) && shouldShowTreeConnectors" class="parent-child-line" :class="['tree-level-' + (v.level + 1), { 'inverted': isChildrenAboveParent(v) }]" :style="{ left: ((v.level * 20) + 9) + 'px' }"></div>
                </div>
              </td>
              <!-- Combined GL Code & Description column -->
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <!-- Status cell -->
              <td class="status-cell-commentary" data-testid="ru-data-table__commentary-status-cell">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator
                    :variant="getCommentaryStatusVariant(v)"
                    :custom-label="getCommentaryStatusLabel(v)"
                    size="sm"
                  />
                </template>
                <template v-else>
                  <span class="text--disabled">--</span>
                </template>
              </td>
              <!-- Amount Column -->
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <!-- Proforma Comparison column -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ proformaLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) }}{{ v.variancepercent1 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- Forecast Comparison column -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency(v.variancepercent2.toFixed(1), '', false, true) }}{{ v.variancepercent2 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- Local Commentary Column - Shows both commentaries -->
              <td class="commentary-cell-combined" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <!-- Proforma Commentary -->
                <div class="commentary-card proforma" v-if="v.commentary1 || isActualJVCommentaryValidForLocal(v)">
                  <div class="commentary-card-header">
                    <v-chip x-small color="primary" class="commentary-type-chip">{{ proformaLabel }}</v-chip>
                    <v-chip v-if="isActualJVCommentaryValidForLocal(v)" x-small outlined class="jv-chip">JV</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div v-if="isActualJVCommentaryValidForLocal(v)" class="commentary-text">
                      {{Object.entries(v.jv_commentary1).map(([key, value]) => key + ': ' + value).join(', ')}}
                    </div>
                    <template v-else-if="v.commentary1 && v.commentary1 !== '' && !v.ignorecommentary">
                      <div class="commentary-text">{{ v.commentary1 }}</div>
                      <div class="approval-reason" v-if="v.approvereason">
                        <span class="reason-label">Approval Reason:</span>
                        <span class="reason-value">{{ v.approvereason }}</span>
                      </div>
                    </template>
                  </div>
                </div>
                <!-- Forecast Commentary -->
                <div class="commentary-card forecast" v-if="v.commentary2 || isForecastJVCommentaryValidForLocal(v)">
                  <div class="commentary-card-header">
                    <v-chip x-small color="secondary" class="commentary-type-chip">{{ forecastLabel }}</v-chip>
                    <v-chip v-if="isForecastJVCommentaryValidForLocal(v)" x-small outlined class="jv-chip">JV</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div v-if="isForecastJVCommentaryValidForLocal(v)" class="commentary-text">
                      {{Object.entries(v.jv_commentary2).map(([key, value]) => key + ': ' + value).join(', ')}}
                    </div>
                    <template v-else-if="v.commentary2 && v.commentary2 !== '' && !v.ignorecommentary">
                      <div class="commentary-text">{{ v.commentary2 }}</div>
                      <div class="approval-reason" v-if="v.approvereason">
                        <span class="reason-label">Approval Reason:</span>
                        <span class="reason-value">{{ v.approvereason }}</span>
                      </div>
                    </template>
                  </div>
                </div>
                <!-- Empty state -->
                <div v-if="!v.commentary1 && !v.commentary2 && !isActualJVCommentaryValidForLocal(v) && !isForecastJVCommentaryValidForLocal(v)" class="empty-commentary">
                  <span class="text--disabled">--</span>
                </div>
              </td>
              <!-- Regional Commentary Column -->
              <td class="commentary-cell-combined" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <!-- Proforma Regional Commentary -->
                <div class="commentary-card proforma" v-if="v.regionalcommentary1">
                  <div class="commentary-card-header">
                    <v-chip x-small color="primary" class="commentary-type-chip">{{ proformaLabel }}</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div class="commentary-text">{{ v.regionalcommentary1 }}</div>
                    <div class="approval-reason" v-if="v.regionalapprovereason">
                      <span class="reason-label">Approval Reason:</span>
                      <span class="reason-value">{{ v.regionalapprovereason }}</span>
                    </div>
                  </div>
                </div>
                <!-- Forecast Regional Commentary -->
                <div class="commentary-card forecast" v-if="v.regionalcommentary2">
                  <div class="commentary-card-header">
                    <v-chip x-small color="secondary" class="commentary-type-chip">{{ forecastLabel }}</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div class="commentary-text">{{ v.regionalcommentary2 }}</div>
                    <div class="approval-reason" v-if="v.regionalapprovereason">
                      <span class="reason-label">Approval Reason:</span>
                      <span class="reason-value">{{ v.regionalapprovereason }}</span>
                    </div>
                  </div>
                </div>
                <!-- Empty state -->
                <div v-if="!v.regionalcommentary1 && !v.regionalcommentary2" class="empty-commentary">
                  <span class="text--disabled">--</span>
                </div>
              </td>
            </template>
          </tr>
          <!-- Ungrouped Items Accordion (All Commentary) -->
          <tr v-if="ungroupedGLItems && ungroupedGLItems.length > 0" 
            class="ungrouped-accordion-header cursor-pointer" 
            role="button"
            tabindex="0"
            :aria-expanded="ungroupedAccordionExpanded.toString()"
            @click.stop="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.enter.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
            @keydown.space.stop.prevent="ungroupedAccordionExpanded = !ungroupedAccordionExpanded"
          >
            <td :colspan="(!isRevenueBreakup && !isGlNavigationEnabled) ? 8 : 7" class="pa-2">
              <div class="d-flex align-center">
                <v-icon small class="mr-2">{{ ungroupedAccordionExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                <span class="font-weight-bold text-subtitle-2">Ungrouped Items</span>
                <v-chip x-small class="ml-2" color="grey lighten-2">{{ ungroupedGLItems.length }}</v-chip>
              </div>
            </td>
          </tr>
          <template v-if="ungroupedAccordionExpanded && ungroupedGLItems && ungroupedGLItems.length > 0">
            <tr v-for="v in ungroupedGLItems" :key="'ungrouped-all-' + v._id" class="tree-table ungrouped-item-row cursor-pointer" @click="handleRowClick(v, $event)">
              <td v-if="!isRevenueBreakup && !isGlNavigationEnabled" class="tree-cell">
                <div class="tree-node-wrapper">
                  <div class="tree-expand-icon">
                    <span class="expand-icon">
                      <v-icon small class="leaf-node-icon">mdi-checkbox-blank-outline</v-icon>
                    </span>
                  </div>
                </div>
              </td>
              <td class="gl-code-description-cell">
                <span class="gl-code-description-text">
                  <span class="gl-code">{{ v.glcode_detail.code }}</span>
                  <span class="gl-description">- {{ v.glcode_detail.name }}</span>
                </span>
              </td>
              <td class="status-cell-commentary">
                <template v-if="!v.ignorecommentary">
                  <StatusIndicator :variant="getCommentaryStatusVariant(v)" :custom-label="getCommentaryStatusLabel(v)" size="sm" />
                </template>
                <template v-else><span class="text--disabled">--</span></template>
              </td>
              <td class="text-right actual-amount-cell">
                <span class="font-weight-medium">{{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}</span>
              </td>
              <!-- Proforma Comparison -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ proformaLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount1 > 0 ? 'positive' : v.varianceamount1 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) }}{{ v.variancepercent1 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- Forecast Comparison -->
              <td class="comparison-cell">
                <div class="comparison-card">
                  <div class="comparison-row">
                    <span class="comparison-label">{{ (cycletype === 'Forecast') ? 'Previous ' + forecastLabel : forecastLabel }}</span>
                    <span class="comparison-value">{{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}</span>
                  </div>
                  <div class="comparison-row variance-row">
                    <span class="comparison-label">Variance</span>
                    <div class="variance-values">
                      <span :class="['variance-amount', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        {{ $nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true) }}
                      </span>
                      <span :class="['variance-percent', v.varianceamount2 > 0 ? 'positive' : v.varianceamount2 < 0 ? 'negative' : '']">
                        ({{ $nova.formatCurrency(v.variancepercent2.toFixed(1), '', false, true) }}{{ v.variancepercent2 !== 0 ? '%' : '' }})
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- Local Commentary -->
              <td class="commentary-cell-combined" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div class="commentary-card proforma" v-if="v.commentary1 || isActualJVCommentaryValidForLocal(v)">
                  <div class="commentary-card-header">
                    <v-chip x-small color="primary" class="commentary-type-chip">{{ proformaLabel }}</v-chip>
                    <v-chip v-if="isActualJVCommentaryValidForLocal(v)" x-small outlined class="jv-chip">JV</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div v-if="isActualJVCommentaryValidForLocal(v)" class="commentary-text">
                      {{Object.entries(v.jv_commentary1).map(([key, value]) => key + ': ' + value).join(', ')}}
                    </div>
                    <template v-else-if="v.commentary1 && v.commentary1 !== '' && !v.ignorecommentary">
                      <div class="commentary-text">{{ v.commentary1 }}</div>
                    </template>
                  </div>
                </div>
                <div class="commentary-card forecast" v-if="v.commentary2 || isForecastJVCommentaryValidForLocal(v)">
                  <div class="commentary-card-header">
                    <v-chip x-small color="secondary" class="commentary-type-chip">{{ forecastLabel }}</v-chip>
                    <v-chip v-if="isForecastJVCommentaryValidForLocal(v)" x-small outlined class="jv-chip">JV</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div v-if="isForecastJVCommentaryValidForLocal(v)" class="commentary-text">
                      {{Object.entries(v.jv_commentary2).map(([key, value]) => key + ': ' + value).join(', ')}}
                    </div>
                    <template v-else-if="v.commentary2 && v.commentary2 !== '' && !v.ignorecommentary">
                      <div class="commentary-text">{{ v.commentary2 }}</div>
                    </template>
                  </div>
                </div>
                <div v-if="!v.commentary1 && !v.commentary2 && !isActualJVCommentaryValidForLocal(v) && !isForecastJVCommentaryValidForLocal(v)" class="empty-commentary">
                  <span class="text--disabled">--</span>
                </div>
              </td>
              <!-- Regional Commentary -->
              <td class="commentary-cell-combined" @click.stop="forwardOpenSubmitDialog(v, 'view', false)">
                <div class="commentary-card proforma" v-if="v.regionalcommentary1">
                  <div class="commentary-card-header">
                    <v-chip x-small color="primary" class="commentary-type-chip">{{ proformaLabel }}</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div class="commentary-text">{{ v.regionalcommentary1 }}</div>
                  </div>
                </div>
                <div class="commentary-card forecast" v-if="v.regionalcommentary2">
                  <div class="commentary-card-header">
                    <v-chip x-small color="secondary" class="commentary-type-chip">{{ forecastLabel }}</v-chip>
                  </div>
                  <div class="commentary-card-body">
                    <div class="commentary-text">{{ v.regionalcommentary2 }}</div>
                  </div>
                </div>
                <div v-if="!v.regionalcommentary1 && !v.regionalcommentary2" class="empty-commentary">
                  <span class="text--disabled">--</span>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StatusIndicator from '@/modules/varianceanalysis/components/StatusIndicator.vue';
import StatusFilterMenu from '@/modules/varianceanalysis/components/StatusFilterMenu.vue';
import ClientFilterMenu from '@/modules/varianceanalysis/components/ClientFilterMenu.vue';
import NoDataState from '@/modules/varianceanalysis/components/NoDataState.vue';
import helpers from '@/modules/varianceanalysis/utils/helpers';
import {
  COMMENTARY_STAGE_DEFAULT,
  COMMENTARY_STAGE_LABEL_MAP,
  COMMENTARY_STAGE_VARIANT_MAP,
} from '@/modules/varianceanalysis/utils/statusConstants';
import { VARIANCE_ANALYSIS_UI } from '@/modules/varianceanalysis/utils/constants';

/**
 * RUDataTable Component
 * 
 * This component displays the variance analysis data table for Reporting Units (RU).
 * It supports two view modes:
 * 1. Interactive table view (toggletableview === 0) - Full data table with actions
 * 2. Read-only commentary view (toggletableview !== 0) - Simplified view for reading
 * 
 * Features:
 * - Hierarchical tree structure with expand/collapse functionality
 * - Multi-select for bulk operations
 * - Variance analysis with materiality indicators
 * - Commentary workflow (request, add, approve/reject)
 * - Status tracking and activity logs
 * - Conversation threads for collaboration
 */

export default {
  name: 'RUDataTable',
  components: {
    StatusIndicator,
    StatusFilterMenu,
    ClientFilterMenu,
    NoDataState,
  },
  
  props: {
    // Data Props
    /** @type {Array} Filtered commentary data to display in the table */
    filteredcommentarydata: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Paginated items for current view */
    pagedItems: { type: Array, default: function() { return []; } },
    
    /** @type {Object} List of commentary cycle data indexed by cycle ID */
    commentarycycledatalist: { type: Object, default: function() { return {}; } },
    
    /** @type {Object} Current commentary cycle data */
    commentarycycledata: { type: Object, default: function() { return {}; } },
    
    /** @type {Array} Selected items for multi-select operations */
    multiselectdata: { type: Array, default: function() { return []; } },
    
    // View State Props
    /** @type {Number} Toggle between different view modes (0=interactive, 1=read-only) */
    toggletableview: { type: Number, default: 0 },
    
    /** @type {Number} Toggle between RU view and consolidated view (3=consolidated) */
    toggleview: { type: Number, default: 0 },
    
    /** @type {String} Type of cycle - 'Actual' or 'Forecast' */
    cycletype: { type: String, default: 'Actual' },
    
    /** @type {String} Read view cycle type - 'Proforma' or 'Forecast' */
    cycletypeReadview: { type: String, default: 'Proforma' },
    
    /** @type {Number} Current cycle stage */
    cyclestage: { type: Number, default: 0 },
    
    /** @type {Boolean} Whether all rows are expanded */
    isAllExpanded: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether filters are currently set */
    isFilterSet: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether reporting unit has been clicked */
    isReportingUnitClicked: { type: Boolean, default: false },
    
    // User Role Props
    /** @type {Boolean} Whether current user is a preparer */
    ispreparer: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is an approver */
    isapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is a regional approver */
    isregionalapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is a manager */
    ismanager: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user has view-only access */
    isviewonly: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether Segregation of Duties (SOD) is enabled */
    isSodEnabled: { type: Boolean, default: true },
    
    /** @type {Array} Available RU role options for role selector */
    ruRoleOptions: { type: Array, default: function() { return []; } },
    
    /** @type {String|Number|null} Currently selected RU role */
    selectedRuRole: { type: [String, Number], default: null },

    activeStatementTab: { type: Number, default: 1 }, // 0 = Balance Sheet, 1 = Profit & Loss


    actualLabel: { type: String, default: 'Actual' },
    proformaLabel: { type: String, default: 'Proforma' },
    forecastLabel: { type: String, default: 'Forecast' },
    
    // Workflow Props
    /** @type {Object} Workflow configuration and status */
    workflows: { 
      type: Object, 
      default: function() { 
        return { 
          islocalenabled: true, 
          isregionalenabled: true, 
          isworkflowsenabled: true 
        }; 
      } 
    },
    
    /** @type {Boolean} Whether local RU approval is pending */
    ispendinglocalruapproval: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether regional RU approval is pending */
    ispendingregionalruapproval: { type: Boolean, default: false },
    
    /** @type {String|Array} Workflow text/status */
    workflowtext: { type: [String, Array], default: function() { return []; } },
    
    /** @type {String} Message to display when workflows are disabled */
    workflowsDisabledMessage: { type: String, default: 'workflow disabled' },
    
    // Label Props
    /** @type {String} Label for local commentary (e.g., 'Local', 'Plant') */
    commentary_local_key_label: { type: String, default: 'Local' },
    
    /** @type {String} Label for regional commentary (e.g., 'Regional', 'Country') */
    commentary_regional_key_label: { type: String, default: 'Regional' },
    
    /** @type {String} Label for local controls materiality */
    local_controls_label: { type: String, default: '' },
    
    /** @type {String} Label for local management materiality */
    local_management_label: { type: String, default: '' },
    
    /** @type {String} Label for regional controls materiality */
    regional_controls_label: { type: String, default: '' },
    
    /** @type {String} Label for regional management materiality */
    regional_management_label: { type: String, default: '' },
    
    /** @type {Set|Object} Set of expanded row IDs for tracking expand/collapse state */
    expandedIds: { type: [Object, Set], default: function() { return new Set(); } },
    
    /** @type {Boolean} Whether this is a revenue breakup view (changes header labels and structure) */
    isRevenueBreakup: { type: Boolean, default: false },
    
    /** @type {String} SL View mode - 'grouped' or 'ungrouped' */
    slViewMode: { type: String, default: 'grouped' },
    
    /** @type {Array} Array of expanded group IDs for SL grouped view */
    slExpandedGroups: { type: Array, default: function() { return []; } },
    
    /** @type {Number} SL Grouped View toggle - 0 = Grouped, 1 = Ungrouped (separate from toggletableview) */
    slGroupedView: { type: Number, default: 0 },
    
    /** @type {Function} Function to handle row intersection for virtual scrolling */
    handleIntersectFn: { type: Function, required: false },
    
    /** @type {Object} Configuration for the activity log component */
    activitylogconfiggl: { type: Object, default: function() { return {}; } },
    
    /** @type {String} API base path - 'analysis' for RUDataSection, 'sl_analysis' for GLBreakdown */
    apiBasePath: { type: String, default: 'analysis' },
    
    /** @type {String} Period name passed from parent for SL data */
    periodName: { type: String, default: '' },
    
    /** @type {String} Year name passed from parent for SL data */
    yearName: { type: String, default: '' },
    
    /** @type {Array} Selected filter values for status filtering */
    selectedfilter: { type: Array, default: function() { return []; } },
    
    /** @type {String} Reporting type for statement filter - 'bs' for Balance Sheet, 'pl' for P&L, 'both' for both, defaults to 'pl' */
    reportingType: { type: String, default: 'pl' },
    
    /** @type {Boolean} Whether regional commentary automation is enabled for this reporting unit */
    isRegionalCommentaryAutomationEnabled: { type: Boolean, default: false },

    /** @type {Array} Ungrouped GL items (parent: 'NA') to show in separate accordion */
    ungroupedGLItems: { type: Array, default: () => [] },
    
    // ===== Client Code/Name Filter Props (for SL Breakup) =====
    /** @type {Array} Selected client codes for multiselect filter */
    selectedClientCodes: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Selected client names for multiselect filter */
    selectedClientNames: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Unique client codes available for filter dropdown */
    uniqueClientCodes: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Unique client names available for filter dropdown */
    uniqueClientNames: { type: Array, default: function() { return []; } }
  },

  data() {
    return {
      ungroupedAccordionExpanded: false,
    };
  },
  
  computed: {
    ...mapGetters('varianceanalysis', {
      cachedSLContext: 'getSLData'
    }),
    ...mapGetters(['isGlNavigationEnabled']),
  
    /**
     * Expose shared UI copy constants to template without hardcoding magic strings.
     */
    varianceUiCopy() {
      return VARIANCE_ANALYSIS_UI;
    },
    /**
     * Computed property for multiselect data with getter/setter
     * This allows two-way binding while properly emitting changes to parent
     */
    localMultiselectdata: {
      get() {
        return this.multiselectdata;
      },
      set(value) {
        this.$emit('update:multiselectdata', value);
      }
    },
    
    /**
     * Ungrouped items for SL Breakup ungrouped view
     * Filters out parent/header rows and returns only child items (flat list)
     * NOTE: For SL Breakup, filtering is already done in parent's filteredcommentarydata
     */
    ungroupedItems() {
      if (!this.isRevenueBreakup || !this.pagedItems) {
        return [];
      }
      // Filter out header/parent rows (items with __code === 'NA' or __type === 'header')
      // This handles cases where parent component doesn't pre-filter
      return this.pagedItems.filter(function(item) {
        return item.__code !== 'NA' && item.__type !== 'header';
      });
    },
    
    /**
     * Display items based on view mode
     * For SL Breakup (isRevenueBreakup): filtering is handled in parent's filteredcommentarydata
     * For Grouped view (slGroupedView === 0): shows all items including parents
     * For Ungrouped view (slGroupedView === 1): shows only child items (flat list)
     */
    displayItems() {
      // For GL Breakdown, the parent component (GLBreakdown.vue) already handles
      // the filtering in filteredcommentarydata based on slGroupedView
      // When ungrouped accordion is active, exclude those exact items from the main table
      if (this.ungroupedGLItems && this.ungroupedGLItems.length > 0) {
        const ungroupedCodes = new Set(
          this.ungroupedGLItems
            .map(i => i.__code || i.glcode_detail?.code)
            .filter(Boolean)
        );
        return this.pagedItems.filter(item => {
          const code = item.__code || item.glcode_detail?.code;
          return code !== 'NA' && !ungroupedCodes.has(code);
        });
      }
      return this.pagedItems;
    },
    
    /**
     * Check if we should show the expand icon for a row
     * For Revenue Breakup: Only show in grouped view (slGroupedView === 0), not in ungrouped view
     * For other views: Always show expand icon
     */
    shouldShowExpandIcon() {
      if (!this.isRevenueBreakup) {
        return true; // Always show for non-Revenue Breakup views
      }
      return this.slGroupedView === 0; // Only show in grouped view for Revenue Breakup
    },

    /**
     * Check if all status filters are selected
     * Navigation tree lines should only show when all filters are selected
     * The allFilterValues array has 10 status values: [0, 1, -1, 5, 6, -2, 7, 4, 3, 9]
     */
    areAllStatusFiltersSelected() {
      const allFilterCount = 10; // Total number of status filter options
      return this.selectedfilter && this.selectedfilter.length === allFilterCount;
    },

    /**
     * Check if there are more rows to load (for lazy loading indicator)
     * Compares displayItems count with total filtered data count
     */
    hasMoreRows() {
      if (!this.filteredcommentarydata || !this.displayItems) return false;
      return this.displayItems.length < this.filteredcommentarydata.length;
    },

    /**
     * Check if tree connectors (navigation lines) should be shown
     * Show whenever the table is rendering a hierarchy (any row has level > 0).
     * Previously this was hidden behind status-filter selection, which caused
     * connectors to never render for many default filter states.
     */
    shouldShowTreeConnectors() {
      if (this.isRevenueBreakup) return false;
      return Array.isArray(this.displayItems) && this.displayItems.some((row) => (row?.level || 0) > 0);
    },

    /**
     * Label for the actual/forecast amount column based on cycle type
     */
    actualAmountLabel() {
      return this.cycletype === 'Forecast'
        ? this.forecastLabel
        : this.actualLabel;
    },

    /**
     * Label for proforma amounts
     */
    proformaShortLabel() {
      return this.proformaLabel;
    },

    /**
     * Comparison label for forecast/previous forecast columns
     */
    forecastComparisonBaseLabel() {
      return this.cycletype === 'Forecast'
        ? 'Previous ' + this.forecastLabel
        : this.forecastLabel;
    },

    /**
     * Heading label for Actual Vs Proforma section
     */
    actualVsProformaHeading() {
      return ' Vs ' + this.proformaShortLabel;
    },

    /**
     * Heading label for Actual Vs Forecast section
     */
    actualVsForecastHeading() {
      return ' Vs ' + this.forecastComparisonBaseLabel;
    },

    /**
     * Whether to show vs Proforma columns in List View
     * Shows when cycletypeReadview is 'All' or 'Proforma'
     */
    showProformaColumns() {
      return this.cycletypeReadview === 'All' || this.cycletypeReadview === 'Proforma';
    },

    /**
     * Whether to show vs Forecast columns in List View
     * Shows when cycletypeReadview is 'All' or 'Forecast'
     */
    showForecastColumns() {
      return this.cycletypeReadview === 'All' || this.cycletypeReadview === 'Forecast';
    },

    /**
     * Dynamic colspan for NA rows based on visible columns
     * Base is 12 (all columns), subtract 4 for each hidden column group
     */
    naRowColspan() {
      let colspan = 12;
      if (!this.showProformaColumns) colspan -= 4;
      if (!this.showForecastColumns) colspan -= 4;
      return colspan;
    },

    /**
     * Calculates colspan for the empty state row in List View
     * Counts all visible columns based on current state
     */
    getListViewColspan() {
      let colspan = 0;
      
      // Navigation column (only when GL Navigation is NOT flattened — tree structure is present)
      if (!this.isGlNavigationEnabled) {
        colspan += 1;
      }
      
      // Multiselect column
      if ((this.ispreparer || this.isapprover || this.isregionalapprover) && this.toggleview !== 3) {
        colspan += 1;
      }
      
      // RU Code and RU Name columns (only in toggleview === 3)
      if (this.toggleview === 3) {
        colspan += 2;
      }
      
      colspan += 1; // GL Code & Description
      colspan += 1; // Status
      colspan += 1; // Actual/Forecast amount
      
      // Proforma columns (4 columns when visible)
      if (this.showProformaColumns) {
        colspan += 4;
      }
      
      // Forecast columns (4 columns when visible)
      if (this.showForecastColumns) {
        colspan += 4;
      }
      
      return colspan;
    },

    /**
     * All selectable row identifiers for bulk selection.
     */
    selectableRowIds() {
      const items = Array.isArray(this.displayItems) ? this.displayItems : [];
      return items
        .filter(function(item) {
          return this.isRowSelectable(item);
        }.bind(this))
        .map(function(item) {
          return item._id;
        })
        .filter(function(id) {
          return Boolean(id);
        });
    },

    /**
     * Whether every selectable row is currently selected.
     */
    isAllSelectableRowsChecked() {
      const targetIds = this.selectableRowIds;
      if (!targetIds.length) {
        return false;
      }
      const selectedSet = new Set(this.localMultiselectdata || []);
      return targetIds.every(function(id) {
        return selectedSet.has(id);
      });
    },

    /**
     * True when the selection is partial for select-all checkbox state.
     */
    isSelectAllIndeterminate() {
      const targetIds = this.selectableRowIds;
      if (!targetIds.length) {
        return false;
      }
      const selectedSet = new Set(this.localMultiselectdata || []);
      let selectedCount = 0;
      targetIds.forEach(function(id) {
        if (selectedSet.has(id)) {
          selectedCount += 1;
        }
      });
      return selectedCount > 0 && selectedCount < targetIds.length;
    }
  },
  
  beforeDestroy() {
    this.resetLocalState();
  },
  methods: {
    ...mapActions('varianceanalysis', {
      cacheSLContext: 'cacheSLData'
    }),
    // Import helper methods (for isActualJVCommentaryValidForLocal, etc.)
    ...helpers,

    /**
     * Reset component-specific reactive state on teardown to avoid stale selections
     */
    resetLocalState() {
      this.localMultiselectdata = [];
    },

    /**
     * Determine if a row supports multi-select interactions.
     */
    isRowSelectable(row) {
      if (!row || !row._id) {
        return false;
      }
      if (row.__code === 'NA') {
        return false;
      }
      if (row.hide_action) {
        return false;
      }
      return true;
    },

    /**
     * Toggle select-all behavior for the visible rows.
     */
    handleToggleSelectAll() {
      const targetIds = this.selectableRowIds;
      if (!targetIds.length) {
        return;
      }
      const targetSet = new Set(targetIds);
      if (this.isAllSelectableRowsChecked) {
        const remaining = (this.localMultiselectdata || []).filter(function(id) {
          return !targetSet.has(id);
        });
        this.localMultiselectdata = remaining;
        return;
      }
      const merged = new Set(this.localMultiselectdata || []);
      targetIds.forEach(function(id) {
        merged.add(id);
      });
      this.localMultiselectdata = Array.from(merged);
    },
    
    /**
     * Remove a single client code from the filter selection
     * @param {String} code - The client code to remove
     */
    removeClientCodeFilter(code) {
      const updated = this.selectedClientCodes.filter(c => c !== code);
      this.$emit('update:selected-client-codes', updated);
    },
    
    /**
     * Remove a single client name from the filter selection
     * @param {String} name - The client name to remove
     */
    removeClientNameFilter(name) {
      const updated = this.selectedClientNames.filter(n => n !== name);
      this.$emit('update:selected-client-names', updated);
    },

    /**
     * Handle row click for GL data table rows.
     * Navigate to SL Breakup page for all rows (with or without sl_enabled).
     * The SL breakup page will show the GL data for the clicked row.
     * @param {Object} row - The row data object
     * @param {Event} event - Native click event for interaction guard checks
     */
    handleRowClick(row, event) {
      // Skip rows with NA code (header/summary rows)
      if (row.__code === 'NA') {
        return;
      }
      if (this.shouldIgnoreRowNavigation(event)) {
        return;
      }

      // If in revenue breakup mode, trigger drill-down instead of navigation
      if (this.isRevenueBreakup) {
        this.handleRevenueRowClick(row, event);
        return;
      }

      // Navigate to SL breakup page for all GL rows to show commentary data
      this.forwardSLData(row, 'netsales');
    },

    /**
     * Handle revenue breakup row click to trigger drill-down dialog.
     */
    handleRevenueRowClick(row, event) {
      if (!this.isRevenueBreakup) {
        return;
      }
      // Only block rows without ID, allow headers/parents if they have data
      if (!row || !row._id) {
        return;
      }
      // Summary rows (e.g. TOTCLI) hide actions and should not open commentary
      if (row.hide_action) {
        return;
      }
      if (event && this.shouldIgnoreRevenueRowClick(event)) {
        return;
      }
      this.$emit('open-revenue-commentary', row);
    },

    /**
     * Skip drill-down when interactive controls inside the row are clicked.
     */
    shouldIgnoreRevenueRowClick(event) {
      const target = event && event.target;
      if (!target) {
        return false;
      }
      const interactiveSelectors = [
        'button',
        'a',
        'input',
        'textarea',
        'select',
        'label',
        '[role="button"]',
        '[data-stop-revenue-drilldown]'
      ];
      const shouldBlock = interactiveSelectors.some(function(selector) {
        return target.closest(selector);
      });
      if (shouldBlock) {
        return true;
      }
      if (target.closest('.v-input') || target.closest('.v-icon') || target.closest('.navigation-checkbox-cycle')) {
        return true;
      }
      return false;
    },

    /**
     * Prevent row-level navigation when interactive controls inside the row handle their own actions.
     */
    shouldIgnoreRowNavigation(event) {
      const target = event && event.target;
      if (!target) {
        return false;
      }
      const interactiveSelectors = [
        'button',
        'a',
        'input',
        'textarea',
        'select',
        'label',
        '[role="button"]',
        '.v-input',
        '.v-icon',
        '.navigation-checkbox-cycle',
        '[data-stop-gl-navigation]'
      ];
      return interactiveSelectors.some(function(selector) {
        return target.closest(selector);
      });
    },

    /**
     * Return the StatusIndicator variant for a commentary row.
     */
    getCommentaryStatusVariant(row) {
      const stageKey = this.normalizeStageKey(row);
      return COMMENTARY_STAGE_VARIANT_MAP[stageKey] || COMMENTARY_STAGE_DEFAULT.variant;
    },

    /**
     * Resolve the translated status label for a commentary row.
     */
    getCommentaryStatusLabel(row) {
      const stageKey = this.normalizeStageKey(row);
      const labelInfo = COMMENTARY_STAGE_LABEL_MAP[stageKey] || COMMENTARY_STAGE_DEFAULT;
      // Using fallback label directly to ensure concise status names (e.g. "Approved" instead of "Approved Commentary")
      // as the translation keys point to verbose filter labels
      return labelInfo.fallback;
    },

    /**
     * Normalize the stage value to a string key for lookups.
     */
    normalizeStageKey(row) {
      if (!row || row.__stage === void 0 || row.__stage === null) {
        return '';
      }
      return String(row.__stage);
    },
    
    /**
     * Get reporting unit code for a cycle (avoiding optional chaining in template)
     * @param {String} cycle - Cycle ID
     * @returns {String} RU code
     */
    getRuCode(cycle) {
      const cycleData = this.commentarycycledatalist[cycle];
      return cycleData && cycleData.reportingunit_detail ? cycleData.reportingunit_detail.code : '';
    },
    
    /**
     * Get reporting unit name for a cycle (avoiding optional chaining in template)
     * @param {String} cycle - Cycle ID
     * @returns {String} RU name
     */
    getRuName(cycle) {
      const cycleData = this.commentarycycledatalist[cycle];
      return cycleData && cycleData.reportingunit_detail ? cycleData.reportingunit_detail.name : '';
    },
    
    /**
     * Get activity log URL for a row (avoiding optional chaining in template)
     * @param {Object} v - Row data
     * @returns {String} Activity log URL
     */
    getActivityLogUrl(v) {
      let type = this.commentarycycledata.type;
      if (this.toggleview === 3) {
        const cycleData = this.commentarycycledatalist[v.cycle];
        type = cycleData ? cycleData.type : type;
      }
      return `/v2/varianceanalysis/${this.apiBasePath}/getlogs/${v._id}/f/${type}`;
    },
    
    /**
     * Get conversation API URL
     * @param {Object} v - Row data
     * @param {String} action - API action (getconversation, addconversation, markreadconversation)
     * @returns {String} Conversation API URL
     */
    getConversationUrl(v, action) {
      // Use v2 for sl_analysis and conversation actions, v3 otherwise
      const isSL = this.apiBasePath === 'sl_analysis';
      const isConversationAction = (
        action === 'getconversation' ||
        action === 'addconversation' ||
        action === 'markreadconversation'
      );
      const apiVersion = (isSL && isConversationAction) ? 'v2' : 'v3';
      return `/${apiVersion}/varianceanalysis/${this.apiBasePath}/${action}/${v.cycle}/c/${v._id}`;
    },
    
    /**
     * Handle lazy load trigger when the sentinel row becomes visible
     * Uses IntersectionObserver via v-intersect directive
     * @param {Array} entries - Intersection observer entries
     */
    onLazyLoadTrigger(entries) {
      if (entries && entries[0] && entries[0].isIntersecting) {
        // Emit to parent to load more rows, only if we have at least one item
        if (Array.isArray(this.displayItems) && this.displayItems.length > 0) {
          this.$emit('row-intersect', this.displayItems.length - 1);
        }
      }
    },
    
    /**
     * Handle intersect entry (avoiding optional chaining in template)
     * @param {Array} entries - Intersection entries
     * @param {Number} index - Row index
     */
    handleIntersectEntry(entries, index) {
      if (entries && entries[0] && entries[0].isIntersecting) {
        this.handleRowIntersect(index);
      }
    },
    
    /**
     * Forward toggle expand all event to parent
     */
    forwardToggleExpandAll() {
      this.$emit('toggle-expand-all');
    },
    
    /**
     * Forward toggle expand event to parent
     * @param {Object} item - Item to expand/collapse
     */
    forwardToggleExpand(item) {
      this.$emit('toggle-expand', item);
    },

    /**
     * Determines if the row has local commentary for Actual Vs Proforma comparison
     * @param {Object} row - Table row data
     * @returns {Boolean} True when local commentary exists
     */
    hasProformaLocalCommentary(row) {
      return Boolean(row && !row.ignorecommentary && row.commentary1);
    },

    /**
     * Determines if the row has regional commentary for Actual Vs Proforma
     * @param {Object} row - Table row data
     * @returns {Boolean} True when regional commentary exists
     */
    hasProformaRegionalCommentary(row) {
      return Boolean(row && !row.ignorecommentary && row.regionalcommentary1);
    },

    /**
     * Determines if any commentary (local/regional/JV) exists for Actual Vs Proforma
     * @param {Object} row - Table row data
     * @returns {Boolean} True when commentary exists
     */
    hasProformaCommentary(row) {
      return this.hasProformaLocalCommentary(row) ||
        this.hasProformaRegionalCommentary(row) ||
        this.isActualJVCommentaryValidForLocal(row) ||
        this.isActualJVCommentaryValidForRegional(row);
    },

    /**
     * Determines if the row has local commentary for Actual Vs Forecast
     * @param {Object} row - Table row data
     * @returns {Boolean} True when local commentary exists
     */
    hasForecastLocalCommentary(row) {
      return Boolean(row && !row.ignorecommentary && row.commentary2);
    },

    /**
     * Determines if the row has regional commentary for Actual Vs Forecast
     * @param {Object} row - Table row data
     * @returns {Boolean} True when regional commentary exists
     */
    hasForecastRegionalCommentary(row) {
      return Boolean(row && !row.ignorecommentary && row.regionalcommentary2);
    },

    /**
     * Determines if any commentary (local/regional/JV) exists for Actual Vs Forecast
     * @param {Object} row - Table row data
     * @returns {Boolean} True when commentary exists
     */
    hasForecastCommentary(row) {
      return this.hasForecastLocalCommentary(row) ||
        this.hasForecastRegionalCommentary(row) ||
        this.isForecastJVCommentaryValidForLocal(row) ||
        this.isForecastJVCommentaryValidForRegional(row);
    },
    
    /**
     * Forward get net sales data event to parent
     * Navigate to NetSalesBreakup page
     * @param {Object} row - Row data
     * @param {String} type - Type of navigation ('netsales' or 'revenue')
     * @param {Boolean} openDrilldownTab - If true, opens the Drilldown tab first in GLBreakdown
     */
    async forwardSLData(row, type, openDrilldownTab = false) {
      // Get cycle ID from commentarycycledata or from the row
      const cycleId = this.commentarycycledata._id || row.cycle;
      if (cycleId) {
        const contextPayload = this.buildSlContextPayload(row);
        const cachedSelectionId = this.cachedSLContext && this.cachedSLContext.selectedCommentary
          ? this.cachedSLContext.selectedCommentary._id
          : null;
        const cachedReportingType = this.cachedSLContext ? this.cachedSLContext.reportingType : null;
        // Check if role has changed (compare cached role flags with current props)
        const cachedRoleFlags = this.cachedSLContext ? {
          ispreparer: this.cachedSLContext.ispreparer,
          isapprover: this.cachedSLContext.isapprover,
          isregionalapprover: this.cachedSLContext.isregionalapprover,
        } : null;
        const currentRoleFlags = {
          ispreparer: this.ispreparer,
          isapprover: this.isapprover,
          isregionalapprover: this.isregionalapprover,
        };
        const hasRoleChanged = !cachedRoleFlags ||
          cachedRoleFlags.ispreparer !== currentRoleFlags.ispreparer ||
          cachedRoleFlags.isapprover !== currentRoleFlags.isapprover ||
          cachedRoleFlags.isregionalapprover !== currentRoleFlags.isregionalapprover;
        const cachedSodEnabled = this.cachedSLContext ? this.cachedSLContext.isSodEnabled : null;
        const hasSodStatusChanged = cachedSodEnabled !== null && cachedSodEnabled !== this.isSodEnabled;
        // Check if context is stale: different row, reportingType, role, or SOD status
        const isContextStale = !cachedSelectionId || cachedSelectionId !== row._id || cachedReportingType !== (this.reportingType || 'pl') || hasRoleChanged || hasSodStatusChanged;
        
        
        try {
          if (isContextStale) {
            await this.cacheSLContext(contextPayload);
          }
        } catch (error) {
          console.error('[RUDataTable]: cacheSLContext failed', error);
          return;
        }

        // Use unified commentary route for all breakup types
        const path = `/varianceanalysis/commentary/${cycleId}`;
        
        // Build navigation options with optional tab query param
        const navOptions = { path };
        if (openDrilldownTab) {
          navOptions.query = { tab: 'drilldown' };
        }
          
        // Navigate to the Breakup page using nova.gotoLink for smooth navigation
        this.$nova.gotoLink(navOptions);
      } else {
        if (type === 'revenue') {
          this.$emit('get-revenue-data', row);
        } else {
          this.$emit('get-net-sales-data', row);
        }
      }
    },

    /**
     * Build the Sales Ledger context payload stored in Vuex before navigation
     * @param {Object} row - Selected commentary row
     * @returns {Object} Structured payload for SL context caching
     * 
     * Note: yearName prop contains the year _id value (e.g., "2023") from parent component
     * The year _id is used directly for API calls, not a MongoDB ObjectId
     */
    buildSlContextPayload(row) {
      // Get year ID - yearName prop contains the selectedyear _id from Analysis/Base.vue
      // In this app, year _id is the year value itself (e.g., "2023", "2024")
      const yearId = this.yearName || this.commentarycycledata.year_detail?._id || this.commentarycycledata.year || '';
      
      const glcode = row.glcode || row.glcode_detail?.code || '';
      const periodDetail = this.commentarycycledata.period_detail || row.period_detail || null;
      const reportingUnitDetail = this.commentarycycledata.reportingunit_detail || row.reportingunit_detail || null;
      const yearDetail = this.commentarycycledata.year_detail || row.year_detail || null;
      const summaryAiProforma = row.summarycommentary1 || '';
      const summaryAiForecast = row.summarycommentary2 || '';
      const isJvThresholdExceeded = Boolean(row?.isThresholdExceedJVSummarisation || row?.is_threshold_exceed_jv_summarisation);
      const trendContext = {
        glcode,
        period: this.commentarycycledata.period || row.period || '',
        reportingunit: this.commentarycycledata.reportingunit || row.reportingunit || '',
        year: yearId,
        cycletype: this.cycletype,
      };

      const payload = {
        selectedCommentaryCycle: this.commentarycycledata,
        selectedGLCommentary: row,
        selectedCommentary: row,
        ispreparer: this.ispreparer,
        isapprover: this.isapprover,
        isregionalapprover: this.isregionalapprover,
        isSodEnabled: this.isSodEnabled,
        ruRoleOptions: this.ruRoleOptions,
        selectedRuRole: this.selectedRuRole,
        // slEnabled: true when user is a preparer, false for approvers (view-only mode for drilldown)
        slEnabled: row && row.sl_enabled,
        isPendingLocal: this.ispendinglocalruapproval,
        isPendingRegional: this.ispendingregionalruapproval,
        reportingunit: trendContext.reportingunit,
        reportingUnitDetail,
        period: trendContext.period,
        periodDetail,
        year: yearId,
        yearDetail,
        periodName: this.periodName || this.commentarycycledata.period_detail?.name || '',
        yearName: yearId,
        glcode,
        cycleType: this.cycletype,
        cycleStage: this.cyclestage,
        summaryAiProforma,
        summaryAiForecast,
        showSummaryTab: Boolean((summaryAiProforma && summaryAiProforma.trim()) || (summaryAiForecast && summaryAiForecast.trim())),
        isThresholdExceedJVSummarisation: isJvThresholdExceeded,
        trendContext,
        // Reporting type: 'bs' for Balance Sheet, 'pl' for P&L, 'both' for both - defaults to 'pl'
        reportingType: this.reportingType || 'pl',
        // Regional Commentary Automation flag for approve and submit button
        isRegionalCommentaryAutomationEnabled: this.isRegionalCommentaryAutomationEnabled,
        // Workflow configuration from Base.vue (loaded from API)
        workflows: this.workflows,
      };
      return payload;
    },
    
    /**
     * Forward open submit dialog event to parent
     * @param {Object} row - Row data
     * @param {String} mode - Dialog mode
     * @param {Boolean} approver - Whether user is approver
     */
    forwardOpenSubmitDialog(row, mode, approver) {
      if (approver === void 0) { approver = false; }
      // Summary rows (e.g. TOTCLI) hide actions and should not open commentary
      if (row && row.hide_action) {
        return;
      }
      this.$emit('open-submit-dialog', { row: row, mode: mode, approver: approver });
    },
    
    /**
     * Handle row intersection for virtual scrolling
     * @param {Number} index - Row index
     */
    handleRowIntersect(index) {
      if (this.handleIntersectFn) {
        this.handleIntersectFn(index);
      }
    },
    
    /**
     * Check if a row has children
     * @param {Object} item - The row item to check
     * @returns {Boolean} True if the item has children
     */
    hasChildren(item) {
      // For RevenueBreakup grouped view, check if item is a header with children array
      if (this.isRevenueBreakup) {
        return item && item.__type === 'header' && 
               item.glcode_detail && 
               item.glcode_detail.children && 
               item.glcode_detail.children.length > 0;
      }
      // Original logic for non-RevenueBreakup views
      const childArray = item && item.glcode_detail && item.glcode_detail.children;
      return item && item.glcode_detail && item.glcode_detail.children && childArray.length && 
        childArray.some(function(childId) {
          return this.filteredcommentarydata.some(function(c) {
            return c.glcode_detail.code === childId;
          });
        }.bind(this));
    },
    
    /**
     * Check if a row is expanded
     * @param {Object} item - The row item to check
     * @returns {Boolean} True if the item is expanded
     */
    isExpanded(item) {
      if (!item || !item.glcode_detail) {
        return false;
      }
      // For RevenueBreakup, check if the parent's own code is in expandedIds
      if (this.isRevenueBreakup) {
        // Use __code first (SL Breakup tree structure), fallback to glcode_detail.code
        const code = item.__code || item.glcode_detail.code;
        const normalizedCode = code ? String(code) : '';
        return normalizedCode ? this.expandedIds.has(normalizedCode) : false;
      }
      // Original logic for non-RevenueBreakup views
      if (!item.glcode_detail.children) {
        return false;
      }
      var childarray = item.glcode_detail.children;
      return childarray.some(function(childId) {
        return this.expandedIds.has(childId);
      }.bind(this));
    },
    
    /**
     * Get intersection observer handler for virtual scrolling
     * @param {Object} v - The row item
     * @returns {Function} Intersection handler function
     */
    getIntersectHandler(v) {
      return function(entries) {
        if (entries[0] && entries[0].isIntersecting && this.handleIntersectFn) {
          this.handleIntersectFn(v.__index);
        }
      }.bind(this);
    },

    /**
     * Check if item is the last child among its siblings at the same level
     * @param {Object} item - The row item to check
     * @param {Number} itemIndex - Index of the item in displayItems
     * @returns {Boolean} True if the item is the last child
     */
    isLastChildAtLevel(item, itemIndex) {
      if (!item || item.level === 0) return false;
      
      const items = this.displayItems;
      const currentLevel = item.level;
      
      // Look forward to find if there's another sibling at the same level
      for (let i = itemIndex + 1; i < items.length; i++) {
        const nextItem = items[i];
        if (!nextItem) continue;
        
        // If we hit an item at a lower level (parent level), we're the last child
        if (nextItem.level < currentLevel) {
          return true;
        }
        // If we hit an item at the same level, we're not the last child
        if (nextItem.level === currentLevel) {
          return false;
        }
        // If we hit an item at a higher level (child of current), continue looking
      }
      
      // If we reached the end, we're the last child
      return true;
    },

    /**
     * Check if children appear above this parent item (inverted tree)
     * This happens when children have lower order numbers than parent
     * @param {Object} item - The parent row item
     * @returns {Boolean} True if children appear above parent
     */
    isChildrenAboveParent(item) {
      if (!item || !this.hasChildren(item)) return false;
      
      const items = this.displayItems;
      const itemIndex = items.indexOf(item);
      const children = item.glcode_detail?.children || [];
      
      if (itemIndex <= 0 || children.length === 0) return false;
      
      // Check if any child appears before this item in the list
      for (let i = 0; i < itemIndex; i++) {
        const prevItem = items[i];
        if (prevItem && children.includes(prevItem.glcode_detail?.code)) {
          return true; // Found a child above parent
        }
      }
      
      return false;
    },

    /**
     * Check if item is in an inverted tree (its parent appears below it)
     * @param {Object} item - The row item to check
     * @returns {Boolean} True if this item's parent appears below it
     */
    isInvertedChild(item) {
      if (!item || item.level === 0) return false;
      
      const items = this.displayItems;
      const itemIndex = items.indexOf(item);
      const parentCode = item.glcode_detail?.parent;
      
      if (!parentCode || parentCode === 'primary' || parentCode === 'NA') return false;
      
      // Check if parent appears after this item in the list
      for (let i = itemIndex + 1; i < items.length; i++) {
        const nextItem = items[i];
        if (nextItem && nextItem.glcode_detail?.code === parentCode) {
          return true; // Parent is below this item (inverted)
        }
      }
      
      return false;
    },

    /**
     * Check if item is the first child (in inverted tree, this is the "last" visually)
     * @param {Object} item - The row item to check  
     * @param {Number} itemIndex - Index of the item in displayItems
     * @returns {Boolean} True if the item is the first child in inverted tree
     */
    isFirstChildAtLevel(item, itemIndex) {
      if (!item || item.level === 0) return false;
      
      const items = this.displayItems;
      const currentLevel = item.level;
      
      // Look backward to find if there's another sibling at the same level
      for (let i = itemIndex - 1; i >= 0; i--) {
        const prevItem = items[i];
        if (!prevItem) continue;
        
        // If we hit an item at a lower level (parent level), we're the first child
        if (prevItem.level < currentLevel) {
          return true;
        }
        // If we hit an item at the same level, we're not the first child
        if (prevItem.level === currentLevel) {
          return false;
        }
      }
      
      return true;
    },

    /**
     * Get the tree connector lines that should be shown for this item
     * Returns an array of objects describing each vertical line segment needed
     * @param {Object} item - The row item
     * @param {Number} itemIndex - Index of the item in displayItems
     * @returns {Array} Array of connector configs
     */
    getTreeConnectors(item, itemIndex) {
      if (!item || item.level === 0) return [];
      
      const connectors = [];
      const items = this.displayItems;
      const isInverted = this.isInvertedChild(item);
      
      // For each ancestor level, determine if we need a vertical line
      for (let level = 1; level <= item.level; level++) {
        let hasMoreSiblingsAtLevel = false;
        
        if (isInverted) {
          // For inverted trees, siblings are ABOVE (earlier in array)
          // Check backward to see if there are more siblings at this level
          for (let i = itemIndex - 1; i >= 0; i--) {
            const prevItem = items[i];
            if (!prevItem) continue;
            
            // If we hit an item at a lower level (parent level), stop looking
            if (prevItem.level < level) {
              break;
            }
            // If we hit an item at the same level, we need a vertical line to connect to it
            if (prevItem.level === level) {
              hasMoreSiblingsAtLevel = true;
              break;
            }
          }
        } else {
          // For normal trees, siblings are BELOW (later in array)
          // Check forward to see if there are more siblings at this level
          for (let i = itemIndex + 1; i < items.length; i++) {
            const futureItem = items[i];
            if (!futureItem) continue;
            
            // If we hit an item at a lower level (parent level), stop looking
            if (futureItem.level < level) {
              break;
            }
            // If we hit an item at the same level, we need a vertical line to connect to it
            if (futureItem.level === level) {
              hasMoreSiblingsAtLevel = true;
              break;
            }
          }
        }
        
        const isLastChild = level === item.level && this.isLastChildAtLevel(item, itemIndex);
        const isFirstChild = level === item.level && this.isFirstChildAtLevel(item, itemIndex);
        
        connectors.push({
          level: level,
          showVerticalLine: hasMoreSiblingsAtLevel,
          isCurrentLevel: level === item.level,
          isLastChild: isLastChild,
          isFirstChild: isFirstChild,
          isInverted: isInverted
        });
      }
      
      return connectors;
    }
  }
};
</script>

<style scoped>

/* Lazy load trigger row styling */
.lazy-load-trigger {
  background: transparent !important;
}

.lazy-load-trigger td {
  border-bottom: none !important;
}

/* Row height - 42px minimum for table rows, can expand for content */
.main-table-style ::v-deep tbody tr {
  min-height: 42px;
}

.main-table-style ::v-deep tbody tr td {
  min-height: 42px;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  font-weight: 400;
  font-size: 14px;
  color: #1e293b;
}

.main-table-style ::v-deep thead tr th {
  font-weight: 600;
  font-size: 14px;
  color: #2c2c35 !important;
}
.main-table-style tbody tr:hover {
  background-color: var(--grey-50, #F7F7F7) !important;
}
/* Combined GL Code & Description column styles */
.gl-code-description-column {
  width: 450px !important;
  min-width: 450px;
  max-width: 450px;
}

.gl-code-description-cell {
  width: 450px !important;
  min-width: 450px;
  max-width: 450px;
}

/* GL code description text wrapper - handles ellipsis */
.gl-code-description-text {
  display: block;
  max-width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.client-code-cell {
  min-width: 160px;
}

.client-name-cell {
  min-width: 220px;
}

/* Action column configuration - uses CSS custom property for easy adjustment */
/* Accommodates up to 4 icons (4 x 32px buttons + gaps + padding = ~200px) */
.action-cell,
.action-header {
  --action-column-width: 180px;
  width: var(--action-column-width) !important;
  min-width: var(--action-column-width) !important;
  max-width: var(--action-column-width) !important;
  text-align: center;
}

.action-cell {
  padding: 4px 8px !important;
  overflow: visible;
}

.action-icons {
  gap: 2px;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: var(--space-xs, 8px);
  background: var(--text-icon-combo, #EDEDED);
  cursor: pointer;
  width: -moz-max-content;
  width: fit-content;
  margin: 0 auto;
}

/* Ensure action buttons don't overflow */
.action-icons .v-btn--icon {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.action-icons .v-btn--icon .v-icon {
  font-size: 20px !important;
}

.action-icons img {
  max-width: 22px;
  max-height: 22px;
}

/* Commentary cell styles - grow horizontally with internal scroll for overflow */
.commentary-cell {
  min-width: 400px;
  max-width: 600px;
  max-height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  vertical-align: top;
  cursor: pointer;
}

/* Apply commentary cell style via deep selector for commentary view tables */
.main-table-style ::v-deep .commentary-cell {
  min-width: 400px;
  max-width: 600px;
  max-height: 120px;
  overflow-y: auto;
}

/* Status column in commentary tables - keep text on single line */
.main-table-style ::v-deep td.status-cell-commentary {
  white-space: nowrap;
  min-width: 200px;
  text-align: left;
}

/* Actual amount cell styling */
.main-table-style ::v-deep td.actual-amount-cell {
  font-size: 14px;
  padding-right: 16px !important;
  white-space: nowrap;
}

/* Comparison card styling for variance display */
.main-table-style ::v-deep td.comparison-cell {
  padding: 8px 12px !important;
}

.main-table-style ::v-deep .comparison-card {
  background: var(--grey-50, #F7F7F7);
  border-radius: 8px;
  padding: 10px 14px;
  min-width: 180px;
  border: 1px solid var(--grey-100, #E5E5E5);
}

.main-table-style ::v-deep .comparison-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.main-table-style ::v-deep .comparison-row.variance-row {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--grey-100, #CBCBCC);
}

.main-table-style ::v-deep .comparison-label {
  font-size: 12px;
  color: var(--grey-600, #6B6B6F);
  font-weight: 500;
}

.main-table-style ::v-deep .comparison-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--grey-900, #2C2C35);
}

.main-table-style ::v-deep .variance-values {
  display: flex;
  align-items: center;
  gap: 6px;
}

.main-table-style ::v-deep .variance-amount {
  font-size: 13px;
  font-weight: 600;
}

.main-table-style ::v-deep .variance-percent {
  font-size: 12px;
  font-weight: 500;
}

.main-table-style ::v-deep .variance-amount.positive,
.main-table-style ::v-deep .variance-percent.positive {
  color: var(--green-600, #34A672);
}

.main-table-style ::v-deep .variance-amount.negative,
.main-table-style ::v-deep .variance-percent.negative {
  color: var(--red-500, #E85B61);
}

/* Combined Commentary Cell Styles for "All" view */
.main-table-style ::v-deep td.commentary-cell-combined {
  padding: 8px 12px !important;
  vertical-align: top;
  min-width: 350px;
  max-width: 450px;
  cursor: pointer;
}

.main-table-style ::v-deep .commentary-card {
  background: var(--grey-50, #F7F7F7);
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 8px;
  border-left: 3px solid transparent;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.main-table-style ::v-deep .commentary-card:hover {
  scrollbar-color: var(--grey-200, #CBCBCC) transparent;
}

/* Webkit scrollbar styles for commentary cards */
.main-table-style ::v-deep .commentary-card::-webkit-scrollbar {
  width: 4px;
}

.main-table-style ::v-deep .commentary-card::-webkit-scrollbar-track {
  background: transparent;
}

.main-table-style ::v-deep .commentary-card::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.main-table-style ::v-deep .commentary-card:hover::-webkit-scrollbar-thumb {
  background: var(--grey-200, #CBCBCC);
}

.main-table-style ::v-deep .commentary-card:last-child {
  margin-bottom: 0;
}

.main-table-style ::v-deep .commentary-card.proforma {
  border-left-color: var(--primary-400, #335B77);
  background: var(--primary-50, #E5EBEE);
}

.main-table-style ::v-deep .commentary-card.forecast {
  border-left-color: var(--blue-500, #4285F4);
  background: var(--blue-50, #F3F6FE);
}

.main-table-style ::v-deep .commentary-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: 4px;
}

.main-table-style ::v-deep .commentary-card.proforma .commentary-card-header {
  background: var(--primary-50, #E5EBEE);
}

.main-table-style ::v-deep .commentary-card.forecast .commentary-card-header {
  background: var(--blue-50, #F3F6FE);
}

.main-table-style ::v-deep .commentary-type-chip {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 600;
}

.main-table-style ::v-deep .jv-chip {
  font-size: 9px !important;
  height: 16px !important;
  font-weight: 600;
  color: var(--amber-default, #EBA937) !important;
  border-color: var(--amber-default, #EBA937) !important;
}

.main-table-style ::v-deep .commentary-card-body {
  font-size: 12px;
  line-height: 1.4;
}

.main-table-style ::v-deep .commentary-text {
  color: var(--grey-800, #404047);
  margin-bottom: 4px;
  white-space: normal;
}

.main-table-style ::v-deep .approval-reason {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  border-top: 1px dashed var(--grey-200, #CBCBCC);
  margin-top: 4px;
  flex-wrap: wrap;
}

.main-table-style ::v-deep .reason-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--grey-500, #828285);
  white-space: nowrap;
}

.main-table-style ::v-deep .reason-value {
  font-size: 11px;
  color: var(--grey-700, #55555B);
  font-style: italic;
}

.main-table-style ::v-deep .empty-commentary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.gl-code-description-cell .gl-code {
  /* font-weight: 500; */
  margin-right: 4px;
}

.gl-code-description-cell .gl-description {
  color: var(--v-secondary-base, #666);
}

/* Tree Cell Styles */
.tree-cell {
  position: relative;
  /* padding: 0 !important; */
  min-width: 120px;
  overflow: visible; /* Allow parent-child-line to extend beyond cell */
}

.tree-node-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 42px;
}

.tree-connectors {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%; /* Dynamic height matching row */
  width: 100%;
  pointer-events: none;
}

/* Tree hierarchy level colors - using logo colors from theme */
/* Each nesting level sets a variable; the actual line elements consume it */
.tree-connector-segment,
.parent-child-line {
  --tree-connector-color: var(--color-hierarchy-border, #CBCBCC);
}

.tree-level-1 {
  --tree-connector-color: var(--logo-color, #37ae78); /* Green */
}

/* Tree-level-1 parent-child-line needs fixed left position */
.parent-child-line.tree-level-1 {
  left: 9px !important;
}
.parent-child-line.tree-level-1.inverted {
  left: 9px !important;
}

.tree-level-2 {
  --tree-connector-color: var(--logo-color1, #E85b61); /* Red/Coral */
}

.tree-level-3 {
  --tree-connector-color: var(--logo-color2, #4285f4); /* Blue */
}

.tree-level-4 {
  --tree-connector-color: var(--logo-color3, #6b67ce); /* Purple */
}

.tree-level-5 {
  --tree-connector-color: var(--logo-color, #37ae78); /* Green - cycle back */
}

.tree-level-6 {
  --tree-connector-color: var(--logo-color1, #E85b61); /* Red/Coral - cycle back */
}

/* Support deeper nesting (up to level 8 is used in padding-level-* helpers) */
.tree-level-7 {
  --tree-connector-color: var(--logo-color2, #4285f4); /* Blue - cycle forward */
}

.tree-level-8 {
  --tree-connector-color: var(--logo-color3, #6b67ce); /* Purple - cycle forward */
}

.tree-connector-segment {
      position: absolute;
    top: -5px;
    height: 120%;
    width: 20px;
}

.reset-expander {
  position: absolute;
    top: 0px;
    height: 100%;
    width: 20px;
}


/* Vertical line - runs full height by default to connect siblings */
.vertical-line {
  position: absolute;
  left: -1px;
  top: 4px;
  height: 100%;
  width: 2px;
  background-color: var(--tree-connector-color, var(--color-hierarchy-border, #CBCBCC));
}

/* Half height for last child (L-junction) - line goes from top to middle only */
.vertical-line.half-height {
  height: 58%;
  top: -4px;
}

/* Half height starting from middle going down (for inverted first child) - NOT USED for first child anymore */
.vertical-line.half-height-top {
  top: 50%;
  height: 50%;
}

/* Inverted tree: vertical line extends UPWARD to connect with siblings above */
.tree-connector-segment.is-inverted .vertical-line {
  top: auto;
  bottom: -4px;
  height: 106%; /* Full row height */
}

/* Inverted tree: last child (visual top) needs inverted L - line goes from middle DOWN only */
.tree-connector-segment.is-inverted .vertical-line.half-height {
  height: 54%; /* Half height from middle down */
  top: 50%;
  bottom: auto;
}

/* Inverted tree: first child (visual bottom) should have full height for T-junction */
.tree-connector-segment.is-inverted .vertical-line.half-height-top {
  top: auto;
  bottom: 4px;
  height: 100%; /* Full height to connect upward */
}

/* Horizontal branch - connects to the node at vertical center */
.horizontal-branch {
  position: absolute;
  left: -1px;
  top: 50%; /* Center vertically in the row */
  transform: translateY(-50%);
  width: 12px;
  height: 3px;
  background-color: var(--tree-connector-color, var(--color-hierarchy-border, #CBCBCC));
}

.tree-expand-icon {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 2px;
  position: relative;
}

/* Box icons use primary color */
.expand-icon .v-icon {
  color: var(--v-primary-base, #193541);
}

/* Line extending from expanded parent icon to connect with first child */
.parent-child-line {
  position: absolute;
  /* left is set dynamically via inline style based on level */
  width: 2px;
  left:9px;
  background-color: var(--tree-connector-color, var(--color-hierarchy-border, #CBCBCC));
  /* Extend from icon center down to connect with child row */
  top: 50%; /* Start from middle of expand icon */
  height: calc(50% + 21px); /* Extend to bottom of current row + into next row to meet horizontal branch */
}

/* Inverted: children appear above parent, so line extends upward */
.parent-child-line.inverted {
  top: auto;
  left: 9px;
  bottom: 50%; /* Start from middle of expand icon */
  height: calc(50% + 21px); /* Extend upward to meet child row above */
}

/* ========== RAY TRACING ANIMATION ========== */

/* Line draw animation - vertical downward */
@keyframes rayTraceDown {
  0% {
    clip-path: inset(0 0 100% 0);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

/* Line draw animation - vertical upward */
@keyframes rayTraceUp {
  0% {
    clip-path: inset(100% 0 0 0);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

/* Line draw animation - horizontal */
@keyframes rayTraceRight {
  0% {
    clip-path: inset(0 100% 0 0);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

/* Ensure connectors are visible even if animations/clip-path are disabled */
.parent-child-line,
.tree-connector-segment .vertical-line,
.tree-connector-segment .horizontal-branch {
  clip-path: none;
}

/* Animate only when the user allows motion */
@media (prefers-reduced-motion: no-preference) {
  /* Parent-child line ray trace - only animate once */
  .parent-child-line {
    animation: rayTraceDown 0.6s ease-out 1 forwards;
    animation-fill-mode: forwards;
  }

  .parent-child-line.inverted {
    animation: rayTraceUp 0.6s ease-out 1 forwards;
    animation-fill-mode: forwards;
  }

  /* Vertical line ray trace - hide initially, then animate once */
  .tree-connector-segment .vertical-line {
    clip-path: inset(0 0 100% 0);
    animation: rayTraceDown 0.5s ease-out 1 forwards;
    animation-fill-mode: forwards;
  }

  .tree-connector-segment.is-inverted .vertical-line {
    clip-path: inset(100% 0 0 0);
    animation: rayTraceUp 0.5s ease-out 1 forwards;
    animation-fill-mode: forwards;
  }

  /* Horizontal branch ray trace - hide initially, then animate once */
  .tree-connector-segment .horizontal-branch {
    clip-path: inset(0 100% 0 0);
    animation: rayTraceRight 0.4s ease-out 1 forwards;
    animation-fill-mode: forwards;
  }

  /* Stagger delays by tree level for cascade effect */
  .tree-level-1 .vertical-line { animation-delay: 0.1s; }
  .tree-level-1 .horizontal-branch { animation-delay: 0.3s; }

  .tree-level-2 .vertical-line { animation-delay: 0.2s; }
  .tree-level-2 .horizontal-branch { animation-delay: 0.4s; }

  .tree-level-3 .vertical-line { animation-delay: 0.3s; }
  .tree-level-3 .horizontal-branch { animation-delay: 0.5s; }

  .tree-level-4 .vertical-line { animation-delay: 0.4s; }
  .tree-level-4 .horizontal-branch { animation-delay: 0.6s; }

  .tree-level-5 .vertical-line { animation-delay: 0.5s; }
  .tree-level-5 .horizontal-branch { animation-delay: 0.7s; }

  .tree-level-6 .vertical-line { animation-delay: 0.6s; }
  .tree-level-6 .horizontal-branch { animation-delay: 0.8s; }
}

/* ========== END RAY TRACING ANIMATION ========== */

/* .no-children-spacer {
  display: inline-block;
  width: 24px;
  height: 24px;
} */

/* Empty box icon for leaf nodes (items without children) - uses primary color */
.leaf-node-icon {
  color: var(--v-primary-base, #193541) !important;
}

.scrollable-card-text {
  max-height: 200px;
  /* Adjust the maximum height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.icon {
  margin-right: 8px;
}

.rotate {
  animation: spin 1s linear infinite;
}

.color-box {
  width: 100px;
  height: 100px;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.chip-container {
  display: flex;
  flex-wrap: wrap;
  /* This ensures that the chips wrap when there's no space */
}

.padding-level-0 { padding-left: 0px; }
.padding-level-1 { padding-left: 20px; }
.padding-level-2 { padding-left: 40px; }
.padding-level-3 { padding-left: 60px; }
.padding-level-4 { padding-left: 80px; }
.padding-level-5 { padding-left: 100px; }
.padding-level-6 { padding-left: 120px; }
.padding-level-7 { padding-left: 140px; }
.padding-level-8 { padding-left: 160px; }

.v-table-color{
  margin-bottom: 50px;
}

.childlevele {
  width: 1px;
  background-color: var(--color-hierarchy-border, #d0d0d0);
}


.v-table-color {
  margin-bottom: 50px;
}

/* td.description-cell {
  width: 15% !important;
} */


.parent-row {
  background-color: #e6f7ff !important;
  font-weight: bold;
  cursor: pointer;
}

.child-row td {
  background-color: #f7f7f7;
}

.child-row td:first-child {
  padding-left: 24px !important;
}

.toggle-btn {
  min-width: 24px !important;
}


.fixed-modal-content {
  overflow: hidden !important;
  height:fit-content !important;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: auto;
  /* Removed max-height to allow dynamic growth when expanding nested rows */
}
.table-wrapper{
  /* Removed max-height to allow table to grow dynamically with expanded content */
  overflow-y: visible;
}
.table-wrapper-ungrouped{
    height: 100%;
    position: relative;
}

.v-dialog--scrollable > .v-card > .v-card__text, .v-dialog--scrollable > form > .v-card > .v-card__text {
    overflow-y: auto !important;
    height: auto !important;

}

.gp-1{
  display: flex ;
  gap:1%;
  justify-content: center;
}

/* Set a minimum width for the first column to accommodate expanded content */
.v-data-table ::v-deep td:first-child {
  max-width: 250px;
}


/* Style for the toggle button to maintain position */
.toggle-btn {
  min-width: 24px;
  width: 24px;
}


.commentary1-textarea ::v-deep .v-input__slot {
  height: 300px;
}
.commentary1-textarea ::v-deep .v-input__slot textarea{
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0 2.5px 0 0 !important;
  padding-top: 14px !important;
}
.commentary1-textarea ::v-deep .v-input__append-inner{
  position: absolute;
  right: 5px;
}
.skeleton-textarea{
  height: 200px;
}

.border-left-custom {
  border-left: 4px solid var(--custom-border-color) !important;
}
.custom-view-label ::v-deep .v-label {
    font-size: 1rem;
}

.local-commentary-proforma-margin {
  margin-top: 3%;
}

.local-commentary-forecast-margin {
  margin-top: 3.5%;
}
.role-selector{
  cursor: pointer;
  max-width: min-content;
}
/* Remove border from dropdown */
.role-selector >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  cursor: pointer;
  padding: 0 !important;
}

.role-selector >>> fieldset {
  border: none !important;
  cursor: pointer;
}

.highlight-chip {
  color: #c62828 !important;
}
.highlight-chip .v-icon {
  color: #c62828 !important;
}
.highlight-chip--self {
  font-weight: 600 !important;
  box-shadow:0 0 8px rgba(198, 40, 40, 0.35);
}
::v-deep .v-data-table thead {
  background-color: var(--color-table-header-bg) !important;
}
/* Styles are inherited from parent component */

.flags-cell .mdi:before, .mdi-set{
  font-size: 10px !important;
}

/* Clickable GL row styles */
.clickable-gl-row {
  cursor: pointer;
}
.clickable-gl-row:hover {
  background-color: rgba(var(--v-primary-base), 0.08) !important;
}
/* Drill Down row styles - additional highlight for sl_enabled rows */
.sl-enabled-row {
  cursor: pointer;
}

/* Priority GL row styles - bold text and stronger border on GL code cell */
.gl-priority-row > td {
  border-top: 0.25px solid var(--color-text-primary) !important;
  border-bottom: 0.25px solid var(--color-text-primary) !important;
  border-left: 4px solid var(--color-text-primary) !important;
}
/* Only the last cell gets a right border */
.gl-priority-row > td:last-child {
  border-right: 0.25px solid var(--color-text-primary) !important;
}
.gl-priority-row > td:first-child {
  border-radius: var(--radius-4) 0 0 var(--radius-4) !important;
}
/* Suppress top border on consecutive priority rows to prevent 0.25+0.25=0.50px doubling */
.gl-priority-row + .gl-priority-row > td {
  border-top: none !important;
}
/* Suppress left border on adjacent table cells within priority rows to prevent right+left border doubling */
.gl-priority-row > td + td {
  border-left: none !important;
}

.gl-priority-text {
  font-weight: 700 !important;
  color: var(--color-text-primary) !important;
}

/* Grouped header row background for SL Breakup view */
.sl-grouped-header-row {
  background-color: #f7f7f7 !important;
}

/* Filter icon sizing - matches StatusFilterMenu */
.filter-icon {
  width: 18px;
  height: 18px;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

/* Ungrouped Accordion Styles */
.ungrouped-accordion-header {
  background-color: var(--color-bg-light);
  user-select: none;
  transition: background-color var(--duration-med) var(--ease-standard);
}

.ungrouped-accordion-header:hover {
  background-color: var(--grey-75);
}

.ungrouped-accordion-header td {
  border-top: 2px solid var(--color-border-light) !important;
}

.ungrouped-item-row {
  background-color: var(--grey-weak);
}

.ungrouped-item-row .controls_flag {
  font-size: var(--font-size-2xs) !important;
  margin: 1px 1px !important;
}

.ungrouped-item-row .controls_flag::before {
  font-size: var(--font-size-2xs) !important;
}


</style>
